import uploadImg from "../../assets/images/FileUpload.png"; //draft
import React, { useState, useEffect, useRef, useMemo } from "react";

import { useLocation } from "react-router-dom";
import { useForm, Controller, useWatch, useFieldArray } from "react-hook-form";
import Loading from "../error/Loading";
import { useSelector, useDispatch } from "react-redux";
import "./Progressbar.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import logo from "../../assets/images/vendor-portal.png";
import TextField from "@mui/material/TextField";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import EInvoiceErrorMessage from "./errormessage";
import { Document, Page } from "@react-pdf-viewer/core";
import { Modal } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditNoteOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import {
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardMedia,
  CardActions,
} from "@mui/material";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import axios from "axios";
import { InvoiceAPI } from "../../services/dbApi";
import { ToWords } from "to-words";
import { convertLength } from "@mui/material/styles/cssUtils";
import { combineReducers } from "redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
const toWords = new ToWords();
const CRN_REFERENCE_LOBS = ["ABCL-HO","ABSS","ABCDL","ABHFL"];

const stateMasterCode = {
  1: "JAMMU AND KASMIR",
  2: "HIMACHAL PRADESH",
  3: "PUNJAB",
  4: "CHANDIGARH",
  5: "UTTARAKHAND",
  6: "HARYANA",
  7: "DELHI",
  8: "RAJASTHAN",
  9: "UTTAR PRADESH",
  10: "BIHAR",
  11: "SIKKIM",
  12: "ARUNACHAL PRADESH",
  13: "NAGALAND",
  14: "MANIPUR",
  15: "MIZORAM",
  16: "TRIPURA",
  17: "MEGHALAYA",
  18: "ASSAM",
  19: "WEST BENGAL",
  20: "JHARKHAND",
  21: "ORISSA",
  22: "CHHATTISGARH",
  23: "MADHYA PRADESH",
  24: "GUJARAT",
  26: "DADAR AND NAGAR HAVELI",
  27: "MAHARASTRA",
  29: "KARNATAKA",
  30: "GOA",
  31: "LAKSHADWEEP",
  32: "KERALA",
  33: "TAMIL NADU",
  34: "PONDICHERRY",
  35: "ANDAMAN AND NICOBAR",
  36: "TELENGANA",
  37: "ANDHRA PRADESH",
  38: "LADAKH",
  97: "OTHER TERRITORY",
  96: "OTHER COUNTRIES",
};
const PO_VALIDATION_RULES = {
  DEFAULT: {
    NonPO: 250000,
    EL: 100000000,
    MiscSpent: 25000,
  },
  ABHFL: {
    NonPO: 1000000,
    EL: 100000000,
    MiscSpent: 25000,
  },
};

let maxdate;
let mindate;

//reimbursment module(SS20042026) start
const EXPENSE_BASE_TYPES = ["Utility", "Reimbursement"];
const ABHFL_EXTRA_EXPENSE_TYPE = "Processing_fee";

const getAllowedExpenseType = (value) => {
  //console.log("getAllowedExpenseType triggered")
  return value === "ABHFL"
    ? [...EXPENSE_BASE_TYPES, ABHFL_EXTRA_EXPENSE_TYPE]
    : EXPENSE_BASE_TYPES;
};
//reimbursment module(SS20042026) end

const InvoiceForm = ({ selectedInvoice, setCurrentTab, setInvoiceSuccess }) => {
  const isManualRoundOff = useRef(false);
  const { trigger } = useForm();

  maxdate = new Date(); 
  maxdate.setDate(maxdate.getDate());

  const location = useLocation(); 

  // const { dataItem, userdetails } = location.state;

  //axios.defaults.withCredentials = true;
  const userdetails = useSelector((state) => state.userdetails);
  const dispatch = useDispatch();

  const userID = userdetails?.userData?.userID;

  const checkUserID = process.env.REACT_APP_CHECK_USER_ID;

  /**- Error Handling -**/

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadedSupportFile, setUploadedSupportFile] = useState(null); 
  const [uploadedInvoiceFile, setUploadedInvoiceFile] = useState(null); // to be tested


  const {
    control,
    handleSubmit,
    register,
    setValue,
    getValues,
    reset,
    formState: { errors },
    watch,
    setError: setFormError,
  } = useForm({
    defaultValues: {
      basic_invoice_value: "0",
      discount: "0",
      commodity_charges: "0",
      taxable_value_of_invoice: "0",
      assessable_value: "0",
      customs_duty_others: "0",
      cgst: "0",
      sgst: "0",
      igst: "0",
      utgst: "0",
      cess: "0",
      total_tax_amount: "0",
      other_charges: "0",
      total_invoice_amount: "0",
      round_off_value: "0",
      ...selectedInvoice,
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "originalInvoices",
  });

  useEffect(() => {
    if (
      watch("document_type") === "CRN" &&
      CRN_REFERENCE_LOBS.includes(watch("business_code")) &&
      fields.length === 0
    ) {
      append({
        original_invoice_no: "",
        original_invoice_date: "",
      });
    }

    if (!CRN_REFERENCE_LOBS.includes(watch("business_code"))) {
      setValue("originalInvoices", []);
    }
  }, [watch("document_type"), watch("business_code")]);
  const [showCRNModal, setShowCRNModal] = useState(false);

  /**- Business States -**/
  const [businessCodeList, setBusinessCodeList] = useState();
  const [businessAllGst, setBusinessAllGst] = useState([
    `${selectedInvoice?.business_gstno}`,
  ]);

  /**- Supplier States -**/
  const [suppliersData, setSuppliersData] = useState([]);
  const [supplierAllGst, setSupplierAllGst] = useState([
    `${selectedInvoice?.partner_gstno}`,
  ]);

  /**- PO States -**/
  const [POName, setPOName] = useState([]);
  const [selectedPO, setSelectedPO] = useState();
  const [posDetails, setPosDetails] = useState([]);
  const [showPoType, setPOType] = useState(0);
  const [disableGST, setdisableGST] = useState(1);
  const [document_date, setDocumentDate] = useState();
  const [isShowInput, setIsShowInput] = useState(0);
  const [isShowGstInput, setIsShowGstInput] = useState(0);
  const [showMSME, setShowMSME] = useState(0);
  const [disableMSMENo, setdisableMSMENo] = useState(1);
  const [URDcheck, setURDcheck] = useState(null);

  //reimbursment module (SS20042026) end
  const [showReimbursement, setShowReimbursement] = useState(false);

  const [checkExpenseCategory, setCheckExpenseCategory] = useState(false);

  const handleExpenseCategory = (e) => {
    if (e.target.value === "") {
      setValue("is_einvoice", "");
      setValue("partner_gstno", "");
      return;
    }

    if (e.target.value !== "Processing_fee") {
      setIsEinvoiceEnabled(true);
      setCheckExpenseCategory(true);
      setValue("is_einvoice", "NO");
      setValue("qr_code_with_irn_no", "");
      setValue("partner_gstno", "");
      return;
    }
    setValue("is_einvoice", "");
    setValue("partner_gstno", "");
    setCheckExpenseCategory(false);
  };

  // reimbursment module(SS20042026) end

  // Einvoice invoice date for IRN based invoice start
  const [invoiceDate, setInvoiceDate] = useState("");

  async function convertDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const formatted = `${year}-${month}-${day}`;
    // console.log(formatted);
    return formatted;
  }

  const checkInvoiceDate = (date) => {
    setInvoiceDate(date);

    const toDate = new Date();
    toDate.setDate(toDate.getDate() - 2);
    let formattedToDate = convertDate(toDate);

    const selectedDate = new Date(date);
    let formattedSelectedDate = convertDate(selectedDate);
    // console.log(formattedSelectedDate < formattedToDate);
    if (new Date(formattedSelectedDate) < new Date(formattedToDate)) {
      setErrorMessage(
        "Invoice need 48 hours to reflect on gov complaine portal",
      );
    }
  };
  // Einvoice invoice date for IRN based invoice end

  const [draftAmount, setdraftAmount] = useState();
  const [showTroubleModal, setShowTroubleModal] = useState(false);
  const [showDraftModal, setShowDraftModal] = useState(false);
  //Added -  Helper Function to fetch correct limit
  const getBusinessThreshold = (businessCode, poType) => {
    const rules =
      PO_VALIDATION_RULES[businessCode] || PO_VALIDATION_RULES.DEFAULT;
    switch (poType) {
      case "Non-PO":
        return rules.NonPO;
      case "Engagement-Letter":
        return rules.EL;
      case "Misc-Spent":
        return rules.MiscSpent;
      default:
        return null;
    }
  };

  React.useEffect(() => {
    if (selectedInvoice?.basic_invoice_value) {
      handleInvoiceValues({
        target: {
          name: "basic_invoice_value",
          value: selectedInvoice?.basic_invoice_value,
        },
      });
    }
    selectedInvoice?.document_date &&
      setDocumentDate(
        moment(selectedInvoice?.document_date).format("YYYY-MM-DD"),
      );
    // setInvoiceSuccess({
    //   isInvoiceUploaded: false,
    //   isDraft: false,
    // });
    setInvoiceSuccess({
      isInvoiceUploaded: "test",
      isDraft: "test",
    });
  }, []);

  /**- Invoice States -**/
  const [invoiceList, setInvoiceList] = useState();
  const [isImport, setIsImport] = useState("No");

  const [InvoiceStatus, setInvoiceStatus] = useState("");

  /**- Initial API Calls -**/
  //Vishnavi
  const getAllBusiness = async (userId) => {
    try {
      setError(false);
      const res = await InvoiceAPI.businessAll(userId);
      const uniqueBusinessList = Array.from(
        new Map(
          res?.data?.result.map((business) => [
            business.business_code,
            business,
          ]),
        ).values(),
      );

      setBusinessCodeList(uniqueBusinessList);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        setErrorMessage(error?.response?.data?.message);
      } else {
        setErrorMessage(
          "Internal Server Issue, apologies for the inconvenience caused!",
        );
      }
      setError(true);
      setLoading(false);
    }
  };
  const Invoices = async (userId) => {
    try {
      setLoading(true);
      setError(false);
      const res = await InvoiceAPI.Invoices(userId, getValues("business_code"));
      setInvoiceList(res?.data?.result);
      // setTimeout(() => {
      //   setLoading(false);
      // }, 3000);
      setLoading(false);
      // setLoading(false);
    } catch (error) {
      if (error.response) {
        setErrorMessage(error?.response?.data?.message);
      } else {
        setErrorMessage(
          "Internal Server Isssue,Apologies for the inconvenience caused!",
        );
      }
      setError(true);
      setLoading(false);
      // setTimeout(() => {
      //   setLoading(false);
      // }, 3000);
    }
  };

  useEffect(() => {
    // getAllBusiness(userID[0]);
    // Invoices(userID[0]);
    getAllBusiness(userID);
    Invoices(userID);
  }, [userID]);

  /**- Business Methods Begins-**/
  const changeBusiness = (e) => {
    if (e.target.value === "") {
      reset();
      return;
    }
    setValue("business_code", e.target.value);
    setValue("document_date", null); //tushar
    mindate = new Date();
    getValues("business_code") === "ABSS" ||
    getValues("business_code") === "ABCL-HO"
      ? mindate.setDate(mindate.getDate() - 25)
      : mindate.setDate(mindate.getDate() - 60);

    InvoiceAPI.business(e.target.value)
      .then((res) => {
        if (res.data.result.length !== 0) {
          const fetchBusinessData = res?.data?.result;
          setValue("business_name", fetchBusinessData[0]?.company_name);
          setValue("business_panno", fetchBusinessData[0]?.pan_no);
          const temGSTs = [];
          fetchBusinessData?.map((b, i) => temGSTs.push(b?.gst_no));
          setBusinessAllGst(temGSTs);
        }
      })
      .catch((err) => {
        setError(true);
        //console.log(err);
      });
    /**- SUPPLIER DATA -**/
    // userID[0];

    InvoiceAPI.getSupplier(userID, e.target.value)
      .then((res) => {
        if (res.data.result.length !== 0) {
          const fetchSupplierData = res?.data?.result;
          const URDcheck = fetchSupplierData[0]?.gst_no;
          setURDcheck(URDcheck);
          setSuppliersData(fetchSupplierData);
          const temGSTs = [];
          fetchSupplierData?.map((b) => temGSTs.push(b?.gst_no));
          setSupplierAllGst(temGSTs);
          //  userID[1]
          //console.log(fetchSupplierData);
          setValue("partner_name", userdetails.userData.username);
          setValue("partner_panno", fetchSupplierData[0].pan_no);
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  };
  const changebusinessGstNo = (e) => {
    if (e.target.value === "") {
      setValue("business_billing_address", "");
      setValue("business_email", "");
      setValue("business_state_name", "");
      return;
    }
    InvoiceAPI.businessGST(e.target.value).then((res) => {
      setValue("business_billing_address", res?.data?.result[0]?.full_address);
      setValue("business_email", res?.data?.result[0]?.email);
      setValue("business_state_name", res?.data?.result[0]?.state_name);
    });
  };
  /**- Business Methods Ends -**/
  /**- PO-Suppliers Methods Begins -**/

  //reimbursment module(SS20042026)
  const businessCode = watch("business_code");

  const expenseOptions = useMemo(() => {
    return getAllowedExpenseType(businessCode);
  }, [businessCode]);
  // const expenseOptions = getAllowedExpenseType( watch("business_code"));
  const [showProcessing, setShowProcessing] = useState(false);
  //reimbursment module(SS20042026)

  const handlePOType = (e) => {
    if (e.target.value === "") {
      setPOType(-1);
      setdisableGST(1);
      setShowReimbursement(false); //SS20042026
      setValue("po_type", e.target.value);
      setValue("remaining_amount", "");
      setValue("po_date", "");
      setValue("selected_purchase_order", "");
      setValue("selected_purchase_order", "");
      setValue("partner_address", "");
      setValue("partner_state_name", "");
      setValue("partner_email", "");
      setValue("partner_gst_status", "");
      setValue("partner_gstno", "");
      setValue("qr_code_with_irn_no", ""); //SS20042026
      setValue("is_einvoice", ""); //SS20042026
      return;
    }
    if (e.target.value === "Non-PO") {
      setdisableGST(0);
      setPOType(-1);
      setShowReimbursement(false); //SS20042026
      setValue("po_type", e.target.value);
      setValue("remaining_amount", "");
      setValue("po_date", "");
      setValue("selected_purchase_order", "");
      setValue("remaining_amount", "");
      setValue("partner_state_name", "");
      setValue("partner_email", "");
      setValue("partner_gst_status", "");
      setValue("partner_gstno", "");
      setValue("qr_code_with_irn_no", ""); //SS20042026
      setValue("is_einvoice", ""); //SS20042026
      return;
    }

    //testing for EL
    if (e.target.value === "Engagement-Letter") {
      setdisableGST(0);
      setPOType(2);
      setShowReimbursement(false); //SS20042026
      setValue("po_type", e.target.value);
      setValue("remaining_amount", "");
      setValue("po_date", "");
      setValue("selected_purchase_order", "");
      setValue("remaining_amount", "");
      setValue("partner_state_name", "");
      setValue("partner_email", "");
      setValue("partner_gst_status", "");
      setValue("partner_gstno", "");
      setValue("qr_code_with_irn_no", ""); //SS20042026
      setValue("is_einvoice", ""); //SS20042026
      return;
    }
    //

    //Non-PO amount under 25000
    if (e.target.value === "Misc-Spent") {
      setdisableGST(0);
      setPOType(3);
      setShowReimbursement(false); //SS20042026
      setValue("po_type", e.target.value);
      setValue("remaining_amount", "");
      setValue("po_date", "");
      setValue("selected_purchase_order", "");
      setValue("remaining_amount", "");
      setValue("partner_state_name", "");
      setValue("partner_email", "");
      setValue("partner_gst_status", "");
      setValue("partner_panno", "");
      setValue("partner_gstno", "");
      setValue("qr_code_with_irn_no", ""); //SS20042026
      setValue("is_einvoice", ""); //SS20042026
      return;
    }

    //reimbursment module(SS20042026)
    if (e.target.value === "Other") {
      setdisableGST(0);
      setPOType(-1);
      setShowReimbursement(true);
      setValue("po_type", e.target.value);
      setValue("remaining_amount", "");
      setValue("po_date", "");
      setValue("selected_purchase_order", "");
      setValue("remaining_amount", "");
      setValue("partner_state_name", "");
      setValue("partner_email", "");
      setValue("partner_gst_status", "");
      setValue("partner_gstno", "");
      setValue("qr_code_with_irn_no", "");
      setValue("is_einvoice", "");
      setValue("expense_category", "");
      // setValue("is_einvoice","");
      // setValue("partner_gstno", "");
      if (getValues("business_code") === "ABHFL") {
        (async () => {
          try {
            setLoading(true);
            setError(false);
            const response = await InvoiceAPI.getDepartment(
              // userID[0],
              userID,
              getValues("business_code"),
            );
            //console.log("Calling get department api response ");
            if (response?.data?.result) {
              const showDropdown = response?.data?.showDepartmentDropdown;
              setShowProcessing(showDropdown);
            }
            setLoading(false);
          } catch (error) {
            if (error.response) {
              setErrorMessage(error?.response?.data?.message);
            } else {
              setErrorMessage(
                "Internal Server Isssue,Apologies for the inconvenience caused!",
              );
            }
            setError(true);
            setLoading(false);
          }
        })();
      }
      //console.log("finsied calling department api");
      return;
    }
    //reimbursment module(SS20042026)
    //
    setPOType(0);
    setValue("po_type", e.target.value);
    if (e.target.value === "PO") {
      setdisableGST(1);
      setPOType(1);
      setValue("po_type", e.target.value);
      setValue("qr_code_with_irn_no", ""); //SS20042026
      setValue("is_einvoice", ""); //SS20042026
      setShowReimbursement(false); //SS20042026
    }
    (async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await InvoiceAPI.getPODetails(
          // userID[0],
          userID,
          getValues("business_code"),
        );
        if (response?.data?.result?.length !== 0) {
          const fetchPOData = response?.data?.result;
          setPosDetails(fetchPOData);
          const temGSTs = [];
          fetchPOData?.map((b) => temGSTs.push(b?.purchase_order));
          setPOName(temGSTs);
        }
        // setTimeout(() => {
        //   setLoading(true);
        // }, 2000);
        // setErrorMessage(response);
        setLoading(false);
      } catch (error) {
        if (error.response) {
          setErrorMessage(error?.response?.data?.message);
        } else {
          setErrorMessage(
            "Internal Server Isssue,Apologies for the inconvenience caused!",
          );
        }
        setError(true);
        setLoading(false);
      }
    })();
  };
  const handleOpenPO = (e) => {
    if (selectedInvoice) {
      const selectedPO = e.target.value;
      if (!selectedPO) return;

      const matchedPO = posDetails?.find(
        (item) => item.purchase_order === selectedPO,
      );

      if (!matchedPO) return;

      setSelectedPO(matchedPO);
      setValue("selected_purchase_order", matchedPO.purchase_order);
      setValue("partner_gstno", matchedPO.supplier_gstin || "NA");

      const supplier = suppliersData?.find(
        (item) => item.gst_no === matchedPO.supplier_gstin,
      );
      if (supplier) {
        setValue(
          "partner_address",
          `${supplier.street_house_no} ${supplier.street_2}, ${supplier.postal_code_city}`,
        );
        setValue("partner_panno", supplier.pan_no);
        setValue(
          "partner_state_name",
          stateMasterCode[supplier.gst_no.substring(0, 2)],
        );
        setValue("partner_email", supplier.email_address);
        setValue("partner_gst_status", supplier.status);
        setValue("remaining_amount", matchedPO.remaining_balance);
        setValue("po_date", moment(matchedPO.created_at).format("DD/MM/YYYY"));
        setValue("partner_msme_no", matchedPO.msme_no);
      }
    } else {
      if (e.target.value === "") {
        return;
      }

      let PO = posDetails?.filter(
        (item) => item.purchase_order === e.target.value,
      );
      if (PO.length === 0) {
        return;
      }
      setSelectedPO(PO);
      setValue("partner_gstno", PO ? PO[0]?.supplier_gstin : "NA");
      let supplierList = suppliersData?.filter(
        (item) => item.gst_no === PO[0]?.supplier_gstin,
      );
      if (supplierList.length !== 0) {
        setValue(
          "partner_address",
          supplierList[0]["street_house_no"] +
            " " +
            supplierList[0]["street_2"] +
            " " +
            supplierList[0]["street_3"] +
            "," +
            stateMasterCode[supplierList[0].gst_no.substring(0, 2)] +
            "-" +
            supplierList[0]["postal_code_city"],
        );
        setValue("partner_panno", supplierList[0].pan_no);
        setValue(
          "partner_state_name",
          stateMasterCode[supplierList[0].gst_no.substring(0, 2)],
        );
        setValue("partner_email", supplierList[0].email_address);
        setValue("partner_gst_status", supplierList[0].status);
        setValue("remaining_amount", PO[0]?.remaining_balance);
        setValue("po_date", moment(PO[0]?.created_at).format("DD/MM/YYYY"));
        // setValue("partner_msme_no", PO[0]?.msme_no);
      }
    }
    // Fetch Einvoice applicable status for po
    // const gst_no = getValues("partner_gstno");
    // const businessCode =  getValues("business_code");
    // fetchEInvoiceStatus(gst_no,businessCode);
  };

  const partnerGstNo = useWatch({
    control,
    name: "partner_gstno",
  });

  const selectedPurchaseOrder = useWatch({
    control,
    name: "selected_purchase_order",
  });

  //SS2024
  useEffect(() => {
    if (!partnerGstNo) return;
    if (!(getValues("po_type").toUpperCase() === "OTHER")) {
      //console.log("in if");
      const gst_no = getValues("partner_gstno");
      const businessCode = getValues("business_code");
      fetchEInvoiceStatus(gst_no, businessCode);
    } else if (!checkExpenseCategory) {
      //console.log("in else if");
      const gst_no = getValues("partner_gstno");
      const businessCode = getValues("business_code");
      fetchEInvoiceStatus(gst_no, businessCode);
    }
  }, [partnerGstNo, selectedPurchaseOrder]);
  //SS2024

  const handleSupplierGstNo = (e) => {
    if (e.target.value === "") {
      return;
    }
    const supplierList = suppliersData?.filter(
      (item) => item.gst_no === e.target.value,
    );

    const isURD = URDcheck === "URD";
    if (supplierList.length !== 0) {
      const address = `${supplierList[0]["street_house_no"]} ${supplierList[0]["street_2"]} ${supplierList[0]["street_3"]}`;

      const addressWithState = isURD
        ? address
        : `${address} ${
            stateMasterCode[supplierList[0].gst_no.substring(0, 2)]
          }-${supplierList[0]["postal_code_city"]}`;
      setValue("partner_address", addressWithState);
      setValue("partner_panno", supplierList[0].pan_no);

      if (isURD) {
        setValue("partner_state_name", "");
      } else {
        setValue(
          "partner_state_name",
          stateMasterCode[supplierList[0].gst_no.substring(0, 2)],
        );
      }

      setValue("partner_email", supplierList[0].email_address);
      setValue("partner_gst_status", supplierList[0].status);
      setValue("partner_gstno", supplierList[0].gst_no);
      // setValue("partner_msme_no", supplierList[0]?.msme_no);
    }
    // Fetch Einvoice applicable status for non po
    // const gst_no = getValues("partner_gstno");
    // const businessCode =  getValues("business_code");
    // fetchEInvoiceStatus(gst_no,businessCode);
  };

  const handleMSME = (e) => {
    if (e.target.value === "") {
      setValue("partner_msme_status", e.target.value);
      setShowMSME(0);
      setValue("partner_msme_no", "");
      setdisableMSMENo(1);
    } else if (e.target.value === "Yes") {
      setdisableMSMENo(0);
      setValue("partner_msme_status", e.target.value);
      setValue("partner_msme_no", suppliersData[0]?.msme_no);
      if (suppliersData[0]?.is_msme_certificate === null) {
        setShowMSME(1);
      } else {
        setShowMSME(0);
      }
    } else if (e.target.value === "No") {
      setValue("partner_msme_status", e.target.value);
      setShowMSME(0);
      setValue("partner_msme_no", "NA");
      setdisableMSMENo(1);
    }
  };
  /**- PO-Suppliers Methods Ends -**/

  /**- Invoice Methods Begins -**/
  const [isValidInvoiceValue, setIsValidInvoiceValue] = useState(1);

  //draft is valid test starts
  const [isValidDraftValue, setIsValidDraftValue] = useState(1);

  useEffect(() => {
    const taxableValue = parseFloat(getValues("taxable_value_of_invoice")) || 0;
    const remainingAmount = parseFloat(getValues("remaining_amount")) || 0;
    const poType = getValues("po_type");
    const utilityBill = getValues("expense_category"); //SS20042026

    if (poType === "PO") {
      if (taxableValue > remainingAmount) {
        setIsValidDraftValue(0);
      } else {
        setIsValidDraftValue(1);
      }
    }

    if (poType === "Non-PO") {
      if (draftAmount > 250000) {
        setIsValidDraftValue(0);
      } else {
        setIsValidDraftValue(1);
      }
    }

    if (poType === "Engagement-Letter") {
      if (draftAmount > 250000000) {
        setIsValidDraftValue(0);
      } else {
        setIsValidDraftValue(1);
      }
    }

    if (utilityBill === "Utility") {
      if (draftAmount > 100000) {
        setIsValidDraftValue(0);
      } else {
        setIsValidDraftValue(1);
      }
    }
  }, [
    getValues("taxable_value_of_invoice"),
    getValues("remaining_amount"),
    getValues("total_invoice_amount"),
    getValues("po_type"),
  ]);

  // draft is valid test ends

  const handleInvoiceValues = (e) => {
    let { name, value } = e.target;
    if (value[value.length - 1] === ".") {
      setValue(name, value);
      if (value[value.length - 2] !== 0) {
        setValue(name, value);
      }
    } else {
      let n = value;
      let cntDecimals = value?.split(".")[1]?.length;
      if (value.includes(".") && cntDecimals >= 2) {
        n = parseFloat(value).toFixed(2);
        setValue(name, (n ? n : 0).toString());
      } else {
        if (
          value[value.length - 2] === "." &&
          value[value.length - 1] === "0"
        ) {
          setValue(name, value);
        } else {
          n = parseFloat(parseFloat(n));
          setValue(name, (n ? n : 0.0).toString());
        }
      }
    }
    let basic = getValues("basic_invoice_value");
    let dis = getValues("discount");
    let commodity_charges = getValues("commodity_charges");
    let customs_duty_others = getValues("customs_duty_others");
    let assessable_value =
      parseFloat(basic) - parseFloat(dis) + parseFloat(commodity_charges);

    let taxable_value = (
      parseFloat(assessable_value) + parseFloat(customs_duty_others)
    ).toFixed(2);
    let cgst = parseFloat(getValues("cgst"));
    let sgst = parseFloat(getValues("sgst"));
    let igst = parseFloat(getValues("igst"));
    let utgst = parseFloat(getValues("utgst"));
    let cess = parseFloat(getValues("cess"));

    cgst = parseFloat(getValues("cgst"));
    sgst = parseFloat(getValues("sgst"));
    igst = parseFloat(getValues("igst"));
    utgst = parseFloat(getValues("utgst"));
    let taxamount = (cgst + sgst + igst + utgst + cess).toFixed(2);
    let roundOff = parseFloat(getValues("round_off_value") || 0);
    let total_invoice_amount =
      parseFloat(taxable_value) + parseFloat(taxamount) + roundOff;
    if (!isManualRoundOff.current && name === "basic_invoice_value") {
    }

    const draftInvoiceamount = total_invoice_amount;
    setdraftAmount(draftInvoiceamount);

    setValue("assessable_value", assessable_value.toFixed(2));
    setValue("taxable_value_of_invoice", taxable_value);
    setValue("total_tax_amount", taxamount);
    setValue("total_invoice_amount", total_invoice_amount);
    setValue(
      "total_invoice_amount_in_words",
      toWords.convert(
        getValues("total_invoice_amount")
          ? getValues("total_invoice_amount")
          : "0",
      ) + " Rupees Only",
    );

    if (
      getValues("taxable_value_of_invoice") >
      parseFloat(getValues("remaining_amount"))
    ) {
      setIsValidInvoiceValue(0);
      //notify(); //akshay this cause error in popup in the draft
    } else {
      setIsValidInvoiceValue(1);
    }
    // if (getValues("po_type") === "Non-PO") {
    //   if (getValues("total_invoice_amount") > 250000) {
    //     // console.log(typeof parseInt(value), typeof 1000000000);
    //     setValue("total_invoice_amount", "0");
    //     setValue(
    //       "total_invoice_amount_in_words",
    //       toWords.convert(
    //         getValues("total_invoice_amount")
    //           ? getValues("total_invoice_amount")
    //           : "0"
    //       ) + " Rupees Only"
    //     );
    //     notifyNonPO();
    //     setIsValidInvoiceValue(0);
    //     return;
    //   } else {
    //     setIsValidInvoiceValue(1);
    //   }
    // }

    // Replace hardcoded amount with dynamic validation 14072025
    if (getValues("po_type") === "Non-PO") {
      const businessCode = getValues("business_code");
      const threshold = getBusinessThreshold(businessCode, "Non-PO");
      const invoiceAmt = parseFloat(getValues("total_invoice_amount") || 0);

      if (invoiceAmt > threshold) {
        setValue("total_invoice_amount", "0");
        setValue(
          "total_invoice_amount_in_words",
          toWords.convert("0") + " Rupees Only",
        );

        notifyNonPO(businessCode); // updated below
        setIsValidInvoiceValue(0);
        return;
      } else {
        setIsValidInvoiceValue(1);
      }
    }

    //test EL validations
    if (getValues("po_type") === "Engagement-Letter") {
      if (getValues("total_invoice_amount") > 250000000) {
        setValue("total_invoice_amount", 0);
        setValue(
          "total_invoice_amount_in_words",
          toWords.convert(
            getValues("total_invoice_amount")
              ? getValues("total_invoice_amount")
              : "0",
          ) + " Rupees Only",
        );
        notifyEL();
        setIsValidInvoiceValue(0);
        return;
      } else {
        setIsValidInvoiceValue(1);
      }
    }
    //

    //test Non-Po under 25000 validations
    if (getValues("po_type") === "Misc-Spent") {
      if (getValues("total_invoice_amount") > 25000) {
        setValue("total_invoice_amount", 0);
        setValue(
          "total_invoice_amount_in_words",
          toWords.convert(
            getValues("total_invoice_amount")
              ? getValues("total_invoice_amount")
              : "0",
          ) + " Rupees Only",
        );
        notifyNonPOunder();
        setIsValidInvoiceValue(0);
        return;
      } else {
        setIsValidInvoiceValue(1);
      }
    }

    //SS20042026
    // Utility under 100000 validation
    // console.log('expense_category ',getValues("expense_category"));
    if (getValues("expense_category") === "Utility") {
      if (getValues("total_invoice_amount") > 100000) {
        setValue("total_invoice_amount", 0);
        setValue(
          "total_invoice_amount_in_words",
          toWords.convert(
            getValues("total_invoice_amount")
              ? getValues("total_invoice_amount")
              : "0",
          ) + " Rupees Only",
        );
        notifyUtilityunder();
        setIsValidInvoiceValue(0);
        return;
      } else {
        setIsValidInvoiceValue(1);
      }
    }

    // Reimbursement under 50,000 validation
    // console.log('expense_category ',getValues("expense_category"));
    if (getValues("expense_category") === "Reimbursement") {
      if (getValues("total_invoice_amount") > 50000) {
        setValue("total_invoice_amount", 0);
        setValue(
          "total_invoice_amount_in_words",
          toWords.convert(
            getValues("total_invoice_amount")
              ? getValues("total_invoice_amount")
              : "0",
          ) + " Rupees Only",
        );
        notifyReimbursement();
        setIsValidInvoiceValue(0);
        return;
      } else {
        setIsValidInvoiceValue(1);
      }
    }
    //SS20042026
  };

  const [isRCM, setRCM] = useState(0);
  const handleGSTRCM = (e) => {
    if (e.target.value === "") {
      setRCM(0);
    } else if (e.target.value === "Yes") {
      setRCM(1);
      setValue("cgst", "0");
      setValue("sgst", "0");
      setValue("igst", "0");
      setValue("utgst", "0");
    } else if (e.target.value === "No") {
      setRCM(0);
    }
  };
  /**- Invoice Methods Ends -**/

  /**- Stepper Begins -**/
  const [invoicemessage, setInvoiceMessage] = useState("");
  const [current, setCurrent] = useState(0);
  const isStepComplete = (currentStep) => current > currentStep;
  const steps = [
    {
      title: "Business Details",
      content: "Business Details",
    },
    {
      title: "Supplier Details",
      content: "Supplier Details",
    },
    {
      title: "Invoice Details",
      content: "Invoice Details",
    },
  ];

  const [isEinvoiceEnabled, setIsEinvoiceEnabled] = useState(true);
  const [iserror, setIsError] = useState("");
  const [einvoiceOtpError, setEinvoiceOtpError] = useState("");
  const [jsonData, setJsonData] = useState(null);
  const [jsonDataToken, setJsonDataToken] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");
  const [isToastonce1, setIsToastOnce1] = useState(false);

  function formatDateToYMD(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }

  const handleNext = async (data, event) => {
    event.preventDefault();
    setIsError("");
    setLoading(true);

    // Einvoice fetch api call if block

    if (current === steps.length - 1) {
      if (getValues("basic_invoice_value") < 0.5) {
        return;
      }

      const formData = new FormData();
      Object.keys(data).forEach((key) => formData.append(key, data[key]));
      if (
        getValues("document_type") === "CRN" &&
        CRN_REFERENCE_LOBS.includes(getValues("business_code"))
      ) {
        const validInvoices = (data.originalInvoices || []).filter(
          (item) =>
            item?.original_invoice_no?.trim() && item?.original_invoice_date,
        );

        if (validInvoices.length === 0) {
          setLoading(false);
          return;
        }

        formData.set("originalInvoices", JSON.stringify(validInvoices));
      } else {
        formData.delete("originalInvoices");
      }

      try {
        setLoading(true);
        setError(false);

        if (selectedInvoice) {
          if (formData.get("invoice_status") == "Draft") {
            formData.delete("invoice_status");
          }
          formData.append("invoice_status", "Submitted");

          // handle files
          formData.delete("invoice_copy");
          formData.delete("supporting_documents");
          formData.set(
            "invoice_copy",
            data?.invoiceFile[0] || selectedInvoice?.invoice_copy,
          );
          formData.set(
            "supporting_documents",
            data?.supportFile[0] || selectedInvoice?.supporting_documents,
          );

          // handle date
          if (selectedInvoice?.document_date) {
            const updateDate = formData.get("document_date");
            const formattedDate = moment(
              selectedInvoice?.document_date,
              "YYYY-MM-DD",
              true,
            ).isValid()
              ? moment(selectedInvoice?.document_date).format("YYYY-MM-DD")
              : null;
            if (formattedDate && updateDate !== formattedDate) {
              formData.delete("document_date");
              formData.append("document_date", updateDate);
            }
          }
          // setting/storing signed_invoice, signed_qrcode and json draft 2811
          if (
            getValues("is_einvoice") === "YES" ||
            getValues("is_einvoice") === "Yes"
          ) {
            formData.set("signed_invoice", jsonData?.signedData?.SignedInvoice);
            formData.set("signed_qrcode", jsonData?.signedData?.SignedQRCode);
             formData.set("AckNo",jsonData?.signedData?.AckNo);
              formData.set("AckDt",jsonData?.signedData?.AckDt);
              formData.set("Status",jsonData?.signedData?.Status);
            const einvoiceJsonFile = JSON.stringify(jsonData);
            formData.set("einvoice_json", einvoiceJsonFile);
          }

          await InvoiceAPI.updateInvoiceDraft(formData);
        } else {
          if (document_date) {
            const formattedDate = moment(document_date).isValid()
              ? moment(document_date).format("YYYY-MM-DD")
              : null;
            if (formattedDate) {
              formData.append("document_date", formattedDate);
            }
          }
          formData.set(
            "invoice_copy",
            data?.invoiceFile[0] || selectInvoiceFile,
          );
          formData.set(
            "supporting_documents",
            data?.supportFile[0] || selectSupportDoc,
          );

          // setting/storing signed_invoice, signed_qrcode and json invoice upload 2811
          if (
            getValues("is_einvoice") === "YES" ||
            getValues("is_einvoice") === "Yes"
          ) {
            formData.set("signed_invoice", jsonData?.signedData?.SignedInvoice);
            formData.set("signed_qrcode", jsonData?.signedData?.SignedQRCode);
             formData.set("AckNo",jsonData?.signedData?.AckNo);
              formData.set("AckDt",jsonData?.signedData?.AckDt);
              formData.set("Status",jsonData?.signedData?.Status);
            const einvoiceJsonFile = JSON.stringify(jsonData);
            formData.set("einvoice_json", einvoiceJsonFile);
          }

          formData.append("partner_code", userID);
          formData.append("invoice_status", "Submitted");

          await InvoiceAPI.uploadInvoice(formData);
        }
        setInvoiceSuccess({ isInvoiceUploaded: "true", isDraft: "false" });
        setLoading(false);
        setShowTroubleModal(true);
      } catch (error) {
        const errMsg =
          error?.response?.data?.message ||
          error?.response?.data?.status_message ||
          error?.response?.data?.error_message ||
          error?.response?.data?.error_message?.code ||
          "Internal Server Issue, Apologies for the inconvenience caused!";
        setErrorMessage(errMsg);
        setError(true);
        setShowTroubleModal(true);
        console.log("invoice error catch", error.errorMessage);
        setInvoiceSuccess({ isInvoiceUploaded: "false", isDraft: "false" });
        setLoading(false);
      }
    } else if (
      (getValues("is_einvoice") === "YES" ||
        getValues("is_einvoice") === "Yes") &&
      current === 1
    ) {
      const todate = new Date();
      todate.setDate(todate.getDate() - 90);
      let minus90Str = formatDateToYMD(todate);
      const gstin_no = getValues("business_gstno");
      // const gstin_no = "27AAGCA5936J2ZD";

      //SS20042026
      const toDate = new Date();
      toDate.setDate(toDate.getDate() - 2);
      let formattedToDate = await convertDate(toDate);

      const selectedDate = new Date(getValues("invoice_date"));
      let formattedSelectedDate = await convertDate(selectedDate);

      if (formattedSelectedDate > formattedToDate) {
        // console.log("formatted date");
         console.log("Date -",formattedSelectedDate);
        setIsError(
          "E-Invoice need 48 hours to reflect on government complaint portal",
        );
        setLoading(false);
        return;
      }
      //SS20042026

      let token = null;
      //const irnNo = getValues("qr_code_with_irn_no");
      const irnNo = getValues("qr_code_with_irn_no")?.toLowerCase();

      try {
        setLoading(true);
        //calling Token Api for Einvoice
        // const tokenRes = await InvoiceAPI.EInvoiceToken(irnNo, gstin_no);

        // setJsonDataToken(tokenRes.data);
        // token = tokenRes?.data?.access_token;

        // const response = await InvoiceAPI.EInvoice(irnNo, gstin_no, token);
        const response = await InvoiceAPI.EInvoice(irnNo, gstin_no);

        if (
          getValues("partner_gstno") !==
          response.data["invoiceData"].SellerDtls.Gstin
        ) {
          throw new Error("Partner GSTIN not valid.Contact backend support.");
        }

        setJsonData(response.data);
        const [day, month, year] =
          response.data["invoiceData"].DocDtls.Dt.split("/");
       
       const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
       /* if (formattedDate < minus30Str) {
          throw new Error(
            "Invoice date exceeds 25-day limit for e-invoice generation!!",
          );
        }*/
       
	if (new Date(formattedDate) < new Date(minus90Str)) {
    	throw new Error("Invoice date exceeds 90-day limit for e-invoice generation!!");
	}
        
        setValue(
          "basic_invoice_value",
          response.data["invoiceData"].ValDtls.AssVal || 0,
          { shouldValidate: true, shouldDirty: true },
        );
        handleInvoiceValues({
          target: {
            name: "basic_invoice_value",
            value: String(response.data["invoiceData"].ValDtls.AssVal),
          },
        });

        setValue(
          "discount",
          response.data["invoiceData"].ValDtls.Discount || 0,
        );
        handleInvoiceValues({
          target: {
            name: "discount",
            value: String(response.data["invoiceData"].ValDtls.Discount || 0),
          },
        });

        setValue("cgst", response.data["invoiceData"].ValDtls.CgstVal || 0);
        handleInvoiceValues({
          target: {
            name: "cgst",
            value: String(response.data["invoiceData"].ValDtls.CgstVal || 0),
          },
        });

        setValue("sgst", response.data["invoiceData"].ValDtls.SgstVal || 0);
        handleInvoiceValues({
          target: {
            name: "sgst",
            value: String(response.data["invoiceData"].ValDtls.SgstVal || 0),
          },
        });

        setValue("igst", response.data["invoiceData"].ValDtls.IgstVal || 0);
        handleInvoiceValues({
          target: {
            name: "igst",
            value: String(response.data["invoiceData"].ValDtls.IgstVal || 0),
          },
        });

        setValue("cess", response.data["invoiceData"].ValDtls.CesVal || 0);
        handleInvoiceValues({
          target: {
            name: "cess",
            value: String(response.data["invoiceData"].ValDtls.CesVal || 0),
          },
        });

        setValue(
          "customs_duty_others",
          response.data["invoiceData"].ValDtls.OthChrg || 0,
        );
        handleInvoiceValues({
          target: {
            name: "cess",
            value: String(response.data["invoiceData"].ValDtls.OthChrg || 0),
          },
        });

        setValue(
          "round_off_value",
          response.data["invoiceData"].ValDtls.RndOffAmt || 0,
        );
        handleInvoiceValues({
          target: {
            name: "round_off_value",
            value: String(response.data["invoiceData"].ValDtls.RndOffAmt || 0),
          },
        });

        setValue("document_no", response.data["invoiceData"].DocDtls.No);
        setValue("document_type", response.data["invoiceData"].DocDtls.Typ);
        setValue("document_date", formattedDate);

        const sortRes = await response.data["invoiceData"].ItemList.sort(
          (a, b) => b.TotItemVal - a.TotItemVal,
        );

        setValue(
          "hsncode_main_item",
          response.data["invoiceData"].ItemList[0].HsnCd,
        );

        if (
          response.data["invoiceData"].ValDtls.CgstVal !== 0 ||
          response.data["invoiceData"].ValDtls.SgstVal !== 0 ||
          response.data["invoiceData"].ValDtls.IgstVal !== 0 ||
          response.data["invoiceData"].ValDtls.CesVal !== 0
        ) {
          setValue("gst_under_rcm", "No");
        } else {
          setValue("gst_under_rcm", "Yes");
        }

        setCurrent((prev) => prev + 1);
        setLoading(false);
        await trigger(["basic_invoice_value"]);
      } catch (error) {
        setIsError(
          error?.response?.data?.result?.errorMessage ||
            error?.response?.data?.error_message?.code ||
            error?.response?.data?.result?.error ||
            error?.message,
        );
      }
      setLoading(false);
      return;
    } else {
      Invoices(userID);
      setCurrent((prev) => prev + 1);
    }
  };
  const handleBack = () => {
    if (getValues("is_einvoice") === "YES") {
      setIsValidInvoiceValue(1);
    }
    setCurrent(current - 1);
  };

  const handleInvoice = () => {
    setCurrent(2);
  };
  /**- Stepper Ends -**/

  /**- Notify-**/
  const notify = () =>
    toast.warn(<h4>Invoice Amount Can't exceed remaining PO Amount!</h4>, {
      autoClose: 3000,
      pauseOnHover: true,
      draggable: true,
      position: "bottom-right",
    });

  // change value to 2.5 Lakh
  const [isToastonce, setIsToastOnce] = useState(false);

  // const notifyNonPO = () => {
  //   if (!isToastonce) {
  //     setIsToastOnce(true);
  //     toast.warn(<h4>Non PO Invoice Amount Can't exceed 2.5 Lakh!</h4>, {
  //       autoClose: 2000,
  //       pauseOnHover: false,
  //       draggable: false,
  //       position: "bottom-right",
  //       onClose: () => setIsToastOnce(false),
  //     });
  //   }
  // };
  //Show toast message with correct limit 14072025
  const notifyNonPO = (businessCode) => {
    if (!isToastonce) {
      setIsToastOnce(true);

      const limit =
        PO_VALIDATION_RULES[businessCode]?.NonPO ||
        PO_VALIDATION_RULES.DEFAULT.NonPO;
      const limitInLakhs = limit / 100000;

      toast.warn(
        <h4>Non PO Invoice Amount Can't exceed ₹{limitInLakhs} Lakh!</h4>,
        {
          autoClose: 2000,
          pauseOnHover: false,
          draggable: false,
          position: "bottom-right",
          onClose: () => setIsToastOnce(false),
          toastId: "warning-1",
        },
      );
    }
  };

  const notifyEL = () => {
    if (!isToastonce) {
      setIsToastOnce(true);
      toast.warn(<h4>Engagement Letter Amount Can't exceed 25 Crore!</h4>, {
        autoClose: 2000,
        pauseOnHover: false,
        draggable: false,
        position: "bottom-right",
        onClose: () => setIsToastOnce(false),
        toastId: "warning-2",
      });
    }
  };

  const notifyNonPOunder = () => {
    if (!isToastonce) {
      setIsToastOnce(true);
      toast.warn(<h4>Miscellaneous spent Amount Can't exceed 25000 ₹ !</h4>, {
        autoClose: 2000,
        pauseOnHover: false,
        draggable: false,
        position: "bottom-right",
        onClose: () => setIsToastOnce(false),
        toastId: "warning-3",
      });
    }
  };

  //SS20042026
  const notifyUtilityunder = () => {
    if (!isToastonce) {
      setIsToastOnce(true);
      toast.warn(<h4>Utility spent Amount Can't exceed 100000 ₹ !</h4>, {
        autoClose: 2000,
        pauseOnHover: false,
        draggable: false,
        position: "bottom-right",
        onClose: () => setIsToastOnce(false),
        toastId: "warning-5",
      });
    }
  };

  const notifyReimbursement = () => {
    if (!isToastonce) {
      setIsToastOnce(true);
      toast.warn(<h4>Reimbursment spent Amount Can't exceed 50000 ₹ !</h4>, {
        autoClose: 2000,
        pauseOnHover: false,
        draggable: false,
        position: "bottom-right",
        onClose: () => setIsToastOnce(false),
        toastId: "warning-6",
      });
    }
  };
  //SS20042026

  const notifyFill = () =>
    toast.warn(<h4>Basic Invoice Value & Document No Required To Draft</h4>, {
      autoClose: 3000,
      pauseOnHover: true,
      draggable: true,
      position: "bottom-right",
      toastId: "warning-4",
    });

  //code to eliminate the error
  const handleDraft = async (data, event) => {
    if (event) event.preventDefault();
    data = getValues();

    if (current === steps.length - 1) {
      if (
        getValues("basic_invoice_value") < 0.5 ||
        getValues("document_no") < 1
      ) {
        notifyFill();
        return;
      }

      const formData = new FormData();
      Object.keys(data).forEach((key) => formData.append(key, data[key]));
      if (
        getValues("document_type") === "CRN" &&
        CRN_REFERENCE_LOBS.includes(getValues("business_code"))
      ) {
        const validInvoices = (data.originalInvoices || []).filter(
          (item) =>
            item?.original_invoice_no?.trim() && item?.original_invoice_date,
        );

        if (validInvoices.length === 0) {
          setLoading(false);
          return;
        }

        formData.set("originalInvoices", JSON.stringify(validInvoices));
      } else {
        formData.delete("originalInvoices");
      }

      // pick files
      const InvoiceFile = data?.invoiceFile?.[0];
      const SupportFile = data?.supportFile?.[0];

      try {
        setLoading(true);
        setError(false);

        if (selectedInvoice) {
          if (InvoiceFile) {
            formData.set("invoice_copy", InvoiceFile);
          } else {
            formData.set("invoice_copy", selectedInvoice?.invoice_copy);
          }

          if (SupportFile) {
            formData.set("supporting_documents", SupportFile);
          } else {
            formData.set(
              "supporting_documents",
              selectedInvoice?.supporting_documents,
            );
          }

          if (selectedInvoice?.document_date) {
            const updateDate = formData.get("document_date");
            const formattedDate = moment(
              selectedInvoice?.document_date,
              "YYYY-MM-DD",
              true,
            ).isValid()
              ? moment(selectedInvoice?.document_date).format("YYYY-MM-DD")
              : null;

            if (formattedDate && updateDate !== formattedDate) {
              formData.set("document_date", updateDate);
            }
          }

          if (
            getValues("is_einvoice") === "YES" ||
            getValues("is_einvoice") === "Yes"
          ) {
            formData.set("signed_invoice", jsonData?.signedData?.SignedInvoice);
            formData.set("signed_qrcode", jsonData?.signedData?.SignedQRCode);
             formData.set("AckNo",jsonData?.signedData?.AckNo);
              formData.set("AckDt",jsonData?.signedData?.AckDt);
              formData.set("Status",jsonData?.signedData?.Status);
            const einvoiceJsonFile = JSON.stringify(jsonData);
            formData.set("einvoice_json", einvoiceJsonFile);
          
          }

          await InvoiceAPI.updateInvoiceDraft(formData);

          setUploadedInvoiceFile(
            InvoiceFile?.name || selectedInvoice?.invoiceFile,
          );
          setUploadedSupportFile(
            SupportFile?.name || selectedInvoice?.supportFile,
          );
        } else {
          if (InvoiceFile) {
            formData.set("invoice_copy", InvoiceFile, InvoiceFile.name);
          } else {
            formData.set("invoice_copy", selectInvoiceFile);
          }

          if (SupportFile) {
            formData.set("supporting_documents", SupportFile);
          } else {
            formData.set("supporting_documents", selectSupportDoc);
          }

          formData.append("partner_code", userID);
          formData.append("invoice_status", "Draft");

          if (document_date) {
            const formattedDate = moment(document_date).isValid()
              ? moment(document_date).format("YYYY-MM-DD")
              : null;
            if (formattedDate) {
              formData.append("document_date", formattedDate);
            }
          }

          if (
            getValues("is_einvoice") === "YES" ||
            getValues("is_einvoice") === "Yes"
          ) {
            formData.set("signed_invoice", jsonData?.signedData?.SignedInvoice);
            formData.set("signed_qrcode", jsonData?.signedData?.SignedQRCode);
             formData.set("AckNo",jsonData?.signedData?.AckNo);
              formData.set("AckDt",jsonData?.signedData?.AckDt);
              formData.set("Status",jsonData?.signedData?.Status);
            const einvoiceJsonFile = JSON.stringify(jsonData);
            formData.set("einvoice_json", einvoiceJsonFile);
           
          }

          await InvoiceAPI.uploadInvoice(formData);

          setUploadedInvoiceFile(InvoiceFile?.name);
          setUploadedSupportFile(SupportFile?.name);
        }
        setInvoiceSuccess({ isInvoiceUploaded: "false", isDraft: "true" });
        setShowDraftModal(true);
        setLoading(false);
      } catch (error) {
        const errMsg =
          error?.response?.data?.message ||
          error?.response?.data?.status_message ||
          error?.response?.data?.error_message ||
          error?.response?.data?.error_message?.code ||
          "Internal Server Issue, Apologies for the inconvenience caused!";
        setErrorMessage(errMsg);
        setError(true);
        setShowDraftModal(true);
        setInvoiceSuccess({ isInvoiceUploaded: "false", isDraft: "false" });
        setLoading(false);
      }
      setCurrent(current + 1);
    }
  };

  // const handleDraft = async (data, event) => {
  //   if (event) event.preventDefault();
  //   data = getValues();

  //   if (current === steps.length - 1) {
  //     if (
  //       getValues("basic_invoice_value") < 1 ||
  //       getValues("document_no") < 1
  //     ) {
  //       notifyFill();
  //       return;
  //     }

  //     const formData = new FormData();
  //     Object.keys(data).forEach((key) => formData.append(key, data[key]));

  //     //draft
  //     if (data?.invoiceFile[0]) {
  //       var InvoiceFile = data?.invoiceFile[0];
  //     }
  //     if (data?.supportFile[0]) {
  //       var SupportFile = data?.supportFile[0];
  //     }
  //     //draft
  //     if (selectedInvoice) {
  //       if (InvoiceFile) {
  //         formData.delete("invoice_copy");
  //         formData.set("invoice_copy", data?.invoiceFile[0]);
  //       } else {
  //         formData.set("invoice_copy", selectedInvoice?.invoice_copy);
  //       }
  //       if (SupportFile) {
  //         formData.delete("supporting_documents");
  //         formData.set("supporting_documents", data?.supportFile[0]);
  //       } else {
  //         formData.set(
  //           "supporting_documents",
  //           selectedInvoice?.supporting_documents
  //         );
  //       }
  //       // console.log(
  //       //   "documentdate853:",
  //       //   moment(document_date).format("YYYY-MM-DD")
  //       // );

  //       // if (document_date) {
  //       //   //tbd
  //       //   formData.delete("document_date");
  //       //   formData.append(
  //       //     "document_date",
  //       //     moment(document_date).format("YYYY-MM-DD")
  //       //   );
  //       // }
  //       //
  //       if (selectedInvoice?.document_date) {
  //         const updateDate = formData.get("document_date");

  //         const formattedDate = moment(
  //           selectedInvoice?.document_date,
  //           "YYYY-MM-DD",
  //           true
  //         ).isValid()
  //           ? moment(selectedInvoice?.document_date).format("YYYY-MM-DD")
  //           : null;

  //         if (formattedDate) {
  //           if (updateDate !== formattedDate) {
  //             formData.delete("document_date");
  //             formData.append("document_date", updateDate);
  //           }
  //         }
  //       }

  //       try {
  //         setLoading(true);
  //         setError(false);
  //         //console.log("Updating invoice inside dashboard");

  //         const response = await InvoiceAPI.updateInvoiceDraft(formData);
  //         console.log("Response for selected Draft:", response?.data);
  //         setUploadedInvoiceFile(
  //           InvoiceFile?.name || selectedInvoice.invoiceFile
  //         );
  //         setUploadedSupportFile(
  //           SupportFile?.name || selectedInvoice.supportFile
  //         );

  //         setInvoiceSuccess({ isInvoiceUploaded: "true", isDraft: "true" });
  //         //  setInvoiceSuccess({ isInvoiceUploaded: true, isDraft: true });
  //         Invoices(userID, getValues("business_code"));
  //         setCurrentTab(0);
  //         setLoading(false);
  //       } catch (error) {
  //         handleApiError(error);
  //       }
  //     } else {
  //       //if (invoiceFile) formData.append("invoice_copy", invoiceFile);//stable
  //       //if (supportFile) formData.append("supporting_documents", supportFile);//stable
  //       if (InvoiceFile) {
  //         formData.delete("invoice_copy");
  //         formData.set("invoice_copy", InvoiceFile, InvoiceFile.name);
  //       } else {
  //         formData.delete("invoice_copy");
  //         formData.set("invoice_copy", selectInvoiceFile);
  //       }
  //       // formData.append("invoice_copy", InvoiceFile);
  //       if (SupportFile) {
  //         formData.append("supporting_documents", SupportFile);
  //       } else {
  //         formData.append("supporting_documents", selectSupportDoc);
  //       }

  //       // if (invoiceFile) formData.append("invoice_copy", data?.invoiceFile[0].name);
  //       //if (supportFile) formData.append("supporting_documents",  data?.supportFile[0].name);

  //       formData.append("partner_code", userID);
  //       formData.append("invoice_status", "Draft");

  //       if (document_date) {
  //         const formattedDate = moment(document_date).isValid()
  //           ? moment(document_date).format("YYYY-MM-DD")
  //           : null;

  //         if (formattedDate) {
  //           formData.append("document_date", formattedDate);
  //         }
  //       }

  //       try {
  //         setLoading(true);
  //         setError(false);

  //         const response = await InvoiceAPI.uploadInvoice(formData);
  //         // console.log("Response for Non-selected Draft:", response?.data);

  //         setUploadedInvoiceFile(InvoiceFile?.name);
  //         setUploadedSupportFile(SupportFile?.name);

  //         setInvoiceSuccess({ isInvoiceUploaded: "true", isDraft: "true" });
  //         //setInvoiceSuccess({ isInvoiceUploaded: true, isDraft: true });
  //         Invoices(userID, getValues("business_code"));
  //         setCurrentTab(0);
  //         setLoading(false);
  //       } catch (error) {
  //         handleApiError(error);
  //       }
  //     }

  //     setCurrent(current + 1);
  //   }
  // };

  const handleApiError = (error) => {
    //console.log("error::", error.response?.data);
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error_message?.code ||
      "Internal Server Issue, Apologies for the inconvenience caused!";

    setErrorMessage(errorMessage);
    setInvoiceMessage(errorMessage);
    setInvoiceSuccess({ isInvoiceUploaded: "false", isDraft: "false" });
    //setInvoiceSuccess({ isInvoiceUploaded: false, isDraft: false });
    setCurrentTab(0);
    setError(true);
    setLoading(false);
  };
  //TBC

  const [selectedName, setSelectedName] = useState("");
  const [selectedSFName, setselectedSFName] = useState("");
  const [selectInvoiceFile, setSelectInvoiceFile] = useState(null);
  const [selectSupportDoc, setSelectSupportDoc] = useState(null);

  const handleFileChange = (event) => {
    // const file = event.target.files[0];

    const file = event.target.files ? event.target.files[0] : null;

    if (!file) {
      return;
    }

    if (file && file.type !== "application/pdf") {
      alert("Please select a PDF file only.");
      event.target.value = null;
      setSelectedName("");
      return;
    }

    const maxSizeInMB = 2;
    if (file.size > maxSizeInMB * 1024 * 1024) {
      alert("File size must be less than 2MB.");
      event.target.value = null;
      setSelectedName("");
      return;
    }
    //setSelectedFile(file);
    //console.log("filename907" + file.name);
    setSelectInvoiceFile(event.target.files[0]);
    setSelectedName(file.name);
  };

  const handleSupportFileChange = (event) => {
    const Supportfile = event.target.files[0];

    //setSelectedFile(file);
    // console.log("filename" + Supportfile.name);
    setSelectSupportDoc(event.target.files[0]);
    setselectedSFName(Supportfile.name);
  };

  useEffect(() => {
    try {
      new Blob();
    } catch (e) {
      console.log(e); // [Invariant Violation: NativeBlobModule is available.]
    }
  });

  //async function getFileName (str)
  function getFileName(str) {
    if (str != null && str.length > 14) {
      return str.substr(0, 10) + "~" + str.substr(-4);
    }
    return str;
  }

  // //working
  useEffect(() => {
    if (selectedInvoice?.po_type === "PO") {
      setPOType(1); // Ensure "Select OPEN PO" is visible
      setValue("po_type", "PO");
      setValue(
        "selected_purchase_order",
        selectedInvoice?.selected_purchase_order || "",
      );

      // If PO list is empty, fetch it
      if (!POName || POName.length === 0) {
        handlePOType({ target: { value: "PO" } });
      }
    }
  }, [selectedInvoice, setValue, POName]);

  useEffect(() => {
    if (selectedInvoice?.po_type === "PO") {
      setPOType(1); // Ensure "Select OPEN PO" is visible

      let selectedPONumber = selectedInvoice?.selected_purchase_order;
      let matchedPO = posDetails?.find(
        (item) => item.purchase_order === selectedPONumber,
      );

      setValue("po_type", "PO"); // Set default PO Type
      setValue("selected_purchase_order", selectedPONumber); // Set default PO Order

      if (matchedPO) {
        setValue("remaining_amount", matchedPO.remaining_balance);
      }
    }
  }, [selectedInvoice, posDetails, setValue]);

  useEffect(() => {
    const selectedPONumber = watch("selected_purchase_order");

    if (!selectedPONumber) {
      //console.log(" No PO selected, exiting useEffect");
      return;
    }

    if (!posDetails || posDetails.length === 0) {
      // console.log(" posDetails is empty or not loaded yet:", posDetails);
      return;
    }

    const matchedPO = posDetails?.find(
      (item) => item.purchase_order === selectedPONumber,
    );

    if (!matchedPO) {
      // console.log(" No matching PO found in posDetails");
      return;
    }

    setValue("remaining_amount", matchedPO.remaining_balance, {
      shouldValidate: true,
    });
    trigger("remaining_amount"); // <-  This forces validation & re-render
  }, [watch("selected_purchase_order"), posDetails, setValue, trigger]);

  //working
  useEffect(() => {
    const selectedPONumber = watch("selected_purchase_order");
    const matchedPO = posDetails.find(
      (item) => item.purchase_order === selectedPONumber,
    );

    if (matchedPO && matchedPO.created_at) {
      const createdAt = new Date(matchedPO.created_at);
      const formattedDate = createdAt.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

      setValue("po_date", formattedDate);
    } else {
      setValue("po_date", "");
    }
  }, [watch("selected_purchase_order"), posDetails, setValue]);

  const [showPopup, setShowPopup] = useState(false);
  const [otpSend, setOtpSend] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpExpired, setOtpExpired] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState("");
  const [einvoiceStatus, setEinvoiceStatus] = useState("");
  const businessCodes = ["ABCL-HO","ABSS","ABCDL","ABHFL"];
  const eInvoiceEligibleBusinessCodes = ["ABCL-HO", "ABSS","ABCDL"];
  const otherPoTypeAllowedBusinessCodes = ["ABCL-HO", "ABSS", "ABHFL", "ABCDL"];
  const [selectEinvRadioCheck, setSelectEinvRadioCheck] = useState(false);

  const handleEinvoiceInvoices = (e) => {
    const event = e.target.value;
    if (selectEinvRadioCheck) {
      e.preventDefault();
      return;
    }

    try {
      //console.log("In handleEinvoiceInvoices Einvoice YES or NO ",e.target.value);
      setValue("is_einvoice", e?.target?.value);
      if (event === "YES" || event === "Yes") {
        setIsEinvoiceEnabled(false);
        setEinvoiceOtpError("");
      } else if (event === "NO" || event === "No") {
        setIsError(null);
        setIsEinvoiceEnabled(true);
        setValue("invoice_date", "");
        if (selectedInvoice?.invoice_status !== "Draft") {
          setValue("qr_code_with_irn_no", "");
          setValue("basic_invoice_value", "0");
          setValue("discount", "0");
          setValue("commodity_charges", "0");
          setValue("taxable_value_of_invoice", "0");
          setValue("cgst", "0");
          setValue("sgst", "0");
          setValue("igst", "0");
          setValue("cess", "0");
          setValue("round_off_value", "0");
          setValue("document_no", "");
          setValue("document_type", "");
          setValue("document_date", "");
          setValue("hsncode_main_item", "");
          setValue("assessable_value", "0");
          setValue("total_invoice_amount", "0");
          setValue("total_tax_amount", "0");
          setValue("total_invoice_amount_in_words", "");
          setValue("gst_under_rcm", "");
        }
      } else {
        setIsEinvoiceEnabled(false);
      }
    } catch (error) {
      //console.log("handleEinvoiceInvoices error ", error);
      setIsError(
        error?.response?.data?.result?.errorMessage ||
          error?.response?.data?.error_message?.code ||
          error?.response?.data?.result?.error ||
          error.message,
      );
      setLoading(false);
      return;
    }
  };

  const fetchEInvoiceStatus = async (gst_no, businessCode) => {
    try {
      //Fetch einvoice status on gst number from db
      const res = await InvoiceAPI.einvoiceStatus(gst_no, businessCode);

      //check business code
      if (eInvoiceEligibleBusinessCodes.includes(businessCode)) {
        const irnGenerationEligibility =
          res?.data?.result[0]?.irnGenerationEligibility;

        if (res?.data?.result.length === 0) {
          return;
        }

        //set value from db
        if (irnGenerationEligibility?.toUpperCase() === "YES") {
          setIsEinvoiceEnabled(false);
          setSelectEinvRadioCheck(true);
        } else if (irnGenerationEligibility?.toUpperCase() === "NO") {
          setIsEinvoiceEnabled(true);
          setSelectEinvRadioCheck(false);
        }

        setValue(
          "is_einvoice",
          res?.data?.result[0]?.irnGenerationEligibility?.toUpperCase(),
        );
        // setSelectedValue(
        //   res.data.result[0].irnGenerationEligibility.toUpperCase()
        // );
        // setSelectEinvRadioCheck(true);
      } else {
        setSelectedValue("");
        setValue("is_einvoice", "");
      }
    } catch (error) {
      console.log("error while fetching einvoice applicable status:", error);
      return;
    }
  };

  // useEffect foe watching einvoice value

  useEffect(() => {
    if (selectedInvoice?.is_einvoice) {
      // console.log("isEninvoice:",selectedInvoice?.isEninvoice, selectedValue);
      setValue("is_einvoice", selectedInvoice?.is_einvoice);
    }
  }, [selectedInvoice, selectedValue]);

  return (
    <>
      <ToastContainer />
      {loading && <Loading />}

      <div className="progress-bar-form-wrapper">
        {/* STEPPER START */}
        {/* <div className="progress-bar-wrapper"> */}
        <div
          className={`progress-bar-wrapper ${showDraftModal ? "blurred" : ""}`}
        >
          <div className="arrow-steps">
            {steps.map((item, i) => (
              <div
                key={i}
                className={
                  current === i ? "arrow-steps step current" : "step done"
                }
              >
                {isStepComplete(i) ? "✔ " : ""}
                {item.title}
              </div>
            ))}
          </div>
          <img src={logo} className="logo-class" alt="" />
        </div>
        {/**- STEPPER END -**/}
        {/* FORM START*/}
        <>
          {loading && <Loading />}
          {/* <form onSubmit={handleSubmit(handleNext)}> */}
          <form>
            {current === 0 ? (
              <>
                <div className="invoice-form-container">
                  <div className="invoice-form-fields">
                    <div className="invoice-form-input-field">
                      <label className="required">Select Business</label>
                      <select
                        {...register("business_code", {
                          required: { value: true, message: "*required" },
                        })}
                        value={watch("business_code")}
                        onChange={(e) => {
                          changeBusiness(e);
                          setValue("business_code", e.target.value);
                        }}
                        disabled={!!selectedInvoice}
                      >
                        <option value="">Select Business</option>
                        {businessCodeList?.map((business, i) => {
                          const businessName =
                            business.company_name || "No Business Name";
                          const paddedName = businessName.padEnd(30, " "); // pad with spaces if less than 30
                          const truncatedName = paddedName.substring(0, 29); // truncate if more than 30

                          return (
                            <option
                              key={i}
                              value={business.business_code}
                              title={businessName}
                            >
                              {`${business.business_code} - ${truncatedName}`}
                            </option>
                          );
                        })}
                      </select>

                      <div className="invoice-form-input-field-extra-holder">
                        {errors?.business_code && (
                          <p className="errorMsg">
                            {errors?.business_code.message}
                          </p>
                        )}
                        {/* <p className="errorMsg">{errorMessage}</p> */}
                      </div>
                    </div>
                    <div className="invoice-form-input-field">
                      <label className="required">Business Name</label>
                      <input
                        type="text"
                        placeholder="Business Name"
                        {...register("business_name", {
                          required: { value: true, message: "*required" },
                        })}
                      />
                      <div className="invoice-form-input-field-extra-holder">
                        {errors?.business_name && (
                          <p className="errorMsg">
                            {errors?.business_name.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="invoice-form-input-field">
                      <label className="required">Business PAN No</label>
                      <input
                        type="text"
                        placeholder="Business PAN NO"
                        name="business_panno"
                        {...register("business_panno", {
                          required: "*required",
                        })}
                      />
                      <div className="invoice-form-input-field-extra-holder">
                        {errors?.business_panno && (
                          <p className="errorMsg">
                            {errors?.business_panno.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="invoice-form-input-field">
                      <label className="required">Business GST No</label>
                      <select
                        {...register("business_gstno", {
                          required: { value: true, message: "*required" },
                        })}
                        onChange={changebusinessGstNo}
                      >
                        <option value="">Select State GST</option>
                        {businessAllGst?.map((p, i) => (
                          <option
                            key={i}
                            value={p}
                            selected={p === selectedInvoice?.business_gstno}
                          >
                            {p}
                          </option>
                        ))}
                      </select>
                      <div className="invoice-form-input-field-extra-holder">
                        {errors?.business_gstno && (
                          <p className="errorMsg">
                            {errors?.business_gstno.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="invoice-form-input-field">
                      <label className="required">Billing Address</label>
                      <input
                        type="text"
                        placeholder="Billing Address"
                        {...register("business_billing_address", {
                          required: "*billing address required",
                        })}
                      />
                      <div className="invoice-form-input-field-extra-holder">
                        {errors?.business_billing_address && (
                          <p className="errorMsg">
                            {errors?.business_billing_address.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="invoice-form-input-field">
                      <label className="required">Business State Name</label>
                      <input
                        type="text"
                        placeholder="Business State Name"
                        {...register("business_state_name", {
                          required: "*required",
                        })}
                      />
                      <div className="invoice-form-input-field-extra-holder">
                        {errors?.business_state_name && (
                          <p className="errorMsg">
                            {errors?.business_state_name.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="invoice-form-input-field">
                      <label className="required">Business Email</label>
                      <input
                        type="email"
                        placeholder="Business Email"
                        {...register("business_email", {
                          required: true,
                          pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                        })}
                      />
                      <div className="invoice-form-input-field-extra-holder">
                        {errors.business_email &&
                          errors.business_email.type === "required" && (
                            <p className="errorMsg">Email is required.</p>
                          )}
                        {errors.business_email &&
                          errors.business_email.type === "pattern" && (
                            <p className="errorMsg">Email is not valid.</p>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : current === 1 ? (
              <>
                {iserror && !isEinvoiceEnabled && (
                  <EInvoiceErrorMessage message={iserror} />
                )}
                <div className="invoice-form-container">
                  <div>
                    <div className="invoice-form-fields">
                      <div className="invoice-form-input-field">
                        <label className="required">Supplier PAN No</label>
                        <input
                          type="text"
                          placeholder="Supplier PAN No"
                          {...register("partner_panno", {
                            required: "*required",
                          })}
                          disabled={showPoType !== 3}
                        />
                        <div className="invoice-form-input-field-extra-holder">
                          {errors?.partner_panno && (
                            <p className="errorMsg">
                              {errors?.partner_panno.message}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="invoice-form-input-field">
                        <label className="required">Select PO Type</label>
                        <select
                          {...register("po_type", { required: "*required" })}
                          onChange={handlePOType}
                          selected={selectedInvoice?.po_type}
                        >
                          <option value="">Select PO Type</option>
                          <option value="PO">PO</option>
                          <option value="Non-PO">Non-PO</option>
                          <option value="Engagement-Letter">
                            Engagement-Letter
                          </option>
                          {otherPoTypeAllowedBusinessCodes.includes(
                            getValues("business_code"),
                          ) && <option value="Other">Other</option>}
                          {userID === checkUserID && (
                            <option value="Misc-Spent">
                              Miscellaneous Spent
                            </option>
                          )}
                        </select>
                        <div className="invoice-form-input-field-extra-holder">
                          {errors?.po_type && (
                            <p className="errorMsg">
                              {errors?.po_type.message}
                            </p>
                          )}
                        </div>
                      </div>
                      {/* openlogic begin*/}
                      {showPoType === 1 ? (
                        <div className="invoice-form-input-field">
                          <label className="required">Select OPEN PO </label>
                          <select
                            {...register("selected_purchase_order", {
                              required: "*required",
                            })}
                            onChange={handleOpenPO}
                          >
                            <option value="">Select OPEN</option>
                            {POName?.map((p, i) => (
                              <option value={POName[i]}>{POName[i]}</option>
                            ))}
                          </select>
                          <div className="invoice-form-input-field-extra-holder">
                            {errors?.selected_purchase_order && (
                              <p className="errorMsg">
                                {errors?.selected_purchase_order.message}
                              </p>
                            )}
                          </div>
                        </div>
                      ) : null}

                      {showPoType === 1 ? (
                        <div className="invoice-form-input-field">
                          <label>Remaining PO Amount</label>
                          <input
                            className="invoice-details-table-remaining-amount po-input"
                            type="text"
                            {...register("remaining_amount")}
                            readOnly
                          />
                          <div className="invoice-form-input-field-extra-holder">
                            {/*ttu*/}
                          </div>
                        </div>
                      ) : null}
                      {showPoType === 1 ? (
                        <div className="invoice-form-input-field">
                          <label className="required">PO Date</label>
                          <input
                            className="po-input"
                            type="text"
                            {...register("po_date")}
                            readOnly
                          />
                          <div className="invoice-form-input-field-extra-holder">
                            {" "}
                            {/*ttu*/}
                          </div>
                        </div>
                      ) : null}

                      {showPoType === 2 ? (
                        <div className="invoice-form-input-field">
                          <label className="required">EL Date</label>
                          <input
                            className="po-input"
                            type="date"
                            {...register("po_date", {
                              required: "*required",
                              pattern: {
                                value: /^\d{4}-\d{2}-\d{2}$/,
                                message: "Invalid date format",
                              },
                            })}
                          />
                          <div className="invoice-form-input-field-extra-holder">
                            {" "}
                            {/*ttu*/}
                          </div>
                        </div>
                      ) : null}
                      {showReimbursement && (
                        <div className="invoice-form-input-field">
                          <label className="required">Expense Category</label>
                          <select
                            // value={category}
                            {...register("expense_category", {
                              required: "*required",
                            })}
                            onChange={handleExpenseCategory}
                          >
                            <option value="">Select Expense</option>
                            {expenseOptions
                              .filter((opt) => {
                                const config =
                                  suppliersData[0]?.config_json?.[
                                    opt.toLowerCase()
                                  ] || false;
                                const condition =
                                  showProcessing || opt !== "Processing_fee";
                                return config && condition;
                              })
                              .map((opt) => (
                                <option key={opt} value={opt}>
                                  {opt}
                                </option>
                              ))}
                          </select>
                          <div className="invoice-form-input-field-extra-holder">
                            {errors?.expense_category && (
                              <p className="errorMsg">
                                {errors?.expense_category?.message}
                              </p>
                            )}
                          </div>
                        </div>
                      )}

                      <div
                        /*className="invoice-form-input-field"*/ className={
                          disableGST == 1
                            ? "invoice-form-input-field-read"
                            : "invoice-form-input-field"
                        }
                      >
                        <label className="required">GST No.</label>
                        <select
                          {...register("partner_gstno", {
                            required: "*required",
                          })}
                          onChange={handleSupplierGstNo}
                          disabled={disableGST === 0 ? false : true}
                        >
                          <option value="">Select State GST</option>
                          {supplierAllGst?.map((p, i) => (
                            <option
                              key={i}
                              value={p}
                              selected={p === selectedInvoice?.partner_gstno}
                            >
                              {p}
                            </option>
                          ))}
                        </select>
                        <div className="invoice-form-input-field-extra-holder">
                          {errors?.partner_gstno && (
                            <p className="errorMsg">
                              {errors?.partner_gstno.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="invoice-form-input-field">
                        <label className="required">Name of Supplier</label>
                        <input
                          type="text"
                          placeholder="Name of Supplier"
                          {...register("partner_name", {
                            required: "*required",
                          })}
                        />
                        <div className="invoice-form-input-field-extra-holder">
                          {errors?.partner_name && (
                            <p className="errorMsg">
                              {errors?.partner_name?.message}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="invoice-form-input-field">
                        <label className="required">Address of Supplier</label>
                        <input
                          type="text"
                          placeholder="Address of Supplier"
                          {...register("partner_address", {
                            required: "*required",
                          })}
                        />
                        <div className="invoice-form-input-field-extra-holder">
                          {errors?.partner_address && (
                            <p className="errorMsg">
                              {errors?.partner_address?.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="invoice-form-input-field">
                        <label className="required">State Name</label>
                        <input
                          type="text"
                          placeholder="State Name"
                          {...register("partner_state_name", {
                            required: true,
                          })}
                        />
                        <div className="invoice-form-input-field-extra-holder">
                          {errors?.partner_state_name && (
                            <p className="errorMsg">
                              {errors?.partner_state_name?.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="invoice-form-input-field">
                        <label className="required">Email</label>
                        <input
                          type="email"
                          placeholder="Email"
                          {...register("partner_email", {
                            required: "*requied",
                          })}
                        />
                        <div className="invoice-form-input-field-extra-holder">
                          {errors?.partner_email && (
                            <p className="errorMsg">
                              {errors?.partner_email?.message}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="invoice-form-input-field">
                        <label className="required">Supplier GST status</label>
                        <input
                          type="text"
                          {...register("partner_gst_status", {
                            required: "*required",
                          })}
                          placeholder="Supplier GST status"
                        ></input>
                        <div className="invoice-form-input-field-extra-holder">
                          {errors?.partner_gst_status && (
                            <p className="errorMsg">
                              {errors?.partner_gst_status?.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="invoice-form-input-field">
                        <label className="required">Type of supply </label>
                        <select
                          {...register("partner_type", {
                            required: "*required",
                          })}
                        >
                          <option value="">
                            Type of supply i.e. B2B or B2C
                          </option>
                          <option value="B2B">B2B</option>
                          <option value="B2C">B2C</option>
                        </select>
                        <div className="invoice-form-input-field-extra-holder">
                          {errors?.partner_type && (
                            <p className="errorMsg">
                              {errors?.partner_type?.message}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="invoice-form-input-field-select">
                        <label className="required">MSME Status</label>
                        <select
                          {...register("partner_msme_status", {
                            required: "*required",
                          })}
                          onChange={handleMSME}
                        >
                          <option value="">Select MSME Status</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>

                        <div className="invoice-form-input-field-extra-holder">
                          {showMSME ? (
                            <>
                              <label>Upload MSME Certificate</label>
                              <input
                                type="file"
                                {...register("msmeCertificate", {
                                  required: "*required",
                                })}
                                placeholder="MSME CERTIFICATE"
                              />
                            </>
                          ) : null}
                          {errors?.partner_msme_status && (
                            <p className="errorMsg">
                              {errors?.partner_msme_status?.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div
                        className={
                          isEinvoiceEnabled
                            ? "invoice-form-input-field-select-read"
                            : "invoice-form-input-field"
                        }
                      >
                        <label htmlFor="">Select Invoice Date</label>
                        <Controller
                          name="invoice_date"
                          control={control}
                          rules={{
                            required: !isEinvoiceEnabled ? "*required" : false,
                            validate: (value) => {
                              if (isEinvoiceEnabled) return true; // Skip validation if disabled

                              return (
                                (value &&
                                  moment(
                                    value,
                                    "YYYY-MM-DD",
                                    true,
                                  ).isValid()) ||
                                "Invalid date"
                              );
                            },
                          }}
                          render={({ field }) => (
                            <DatePicker
                              selected={
                                field.value ? new Date(field.value) : null
                              }
                              placeholderText="Click to Select Date"
                              minDate={mindate}
                              maxDate={maxdate}
                              dateFormat="dd-MM-yyyy"
                              onKeyDown={(e) => {
                                e.preventDefault();
                              }}
                              disabled={isEinvoiceEnabled ? true : false}
                              onChange={(date) =>
                                field.onChange(
                                  date
                                    ? moment(date).format("YYYY-MM-DD")
                                    : null,
                                )
                              }
                              //onChange={checkInvoiceDate}
                            />
                          )}
                        />
                        <div className="invoice-form-input-field-extra-holder">
                          {errors?.invoice_date && (
                            <p className="errorMsg">
                              {errors?.invoice_date?.message}
                            </p>
                          )}
                        </div>
                      </div>

                      {eInvoiceEligibleBusinessCodes.includes(
                        getValues("business_code"),
                      ) && (
                        <div className="invoice-form-input-field">
                          <div className="invoice-form-input-field-main">
                            <div className="invoice-form-input-field-einv">
                              <label className="required" htmlFor="mySelect">
                                EInvoice
                              </label>
                              <div className="invoice-form-input-einvoice-field">
                                <div className="option1">
                                  <input
                                    type="radio"
                                    value="YES"
                                    name="radioSelect"
                                    checked={watch("is_einvoice") === "YES"}
                                    //selected={selectedValue || selectedInvoice?.isEninvoice}
                                    {...register("is_einvoice", {
                                      required: "*required",
                                    })}
                                    onClick={(e) => {
                                      handleEinvoiceInvoices(e);
                                    }}
                                    // readOnly
                                  />
                                  <label htmlFor="">Yes</label>
                                </div>

                                <div className="option2">
                                  <input
                                    type="radio"
                                    value="NO"
                                    name="radioSelect"
                                    checked={watch("is_einvoice") === "NO"}
                                    // selected={selectedValue || selectedInvoice?.isEninvoice}
                                    {...register("is_einvoice", {
                                      required: "*required",
                                    })}
                                    onClick={(e) => {
                                      handleEinvoiceInvoices(e);
                                    }}
                                    // readOnly
                                  />
                                  <label htmlFor="">No</label>
                                </div>
                              </div>
                              <div className="invoice-form-input-field-extra-holder">
                                {errors?.is_einvoice && (
                                  <p className="errorMsg">
                                    {errors?.is_einvoice?.message}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="invoice-form-input-field-irn">
                              <label>QR code with IRN no.</label>
                              <div
                                className={
                                  isEinvoiceEnabled
                                    ? "einvoice-values-input-field-irn-no"
                                    : ""
                                }
                              >
                                <input
                                  type="text"
                                  placeholder="QR code with IRN No"
                                  {...register("qr_code_with_irn_no", {
                                    required: !isEinvoiceEnabled
                                      ? "*required"
                                      : false,
                                  })}
                                  //onChange={defaultEinvoiceValues}
                                  disabled={isEinvoiceEnabled ? true : false}
                                />
                              </div>
                              <div className="invoice-form-input-field-extra-holder">
                                {errors?.qr_code_with_irn_no && (
                                  <p className="errorMsg">
                                    {errors?.qr_code_with_irn_no?.message}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div
                        /*className="invoice-form-input-field-select"*/ className={
                          disableMSMENo == 1
                            ? "invoice-form-input-field-select-read"
                            : "invoice-form-input-field-select"
                        }
                      >
                        <label className="required">MSME No</label>
                        <input
                          type="text"
                          {...register("partner_msme_no", {
                            required: "*required",
                          })}
                          placeholder="MSME NO"
                          disabled={disableMSMENo == 0 ? false : true}
                        ></input>
                        <div className="invoice-form-input-field-extra-holder">
                          {errors?.partner_msme_no && (
                            <p className="errorMsg">
                              {errors?.partner_msme_no?.message}
                            </p>
                          )}
                        </div>
                        {/* <label>MSME CODE - IS MSME CERTIFICATE UPLOADED</label>
                      <label>MSME CERTIFICATE</label> */}
                      </div>

                      <div className="invoice-form-input-field"></div>

                      <div className="invoice-form-input-field"></div>

                      <div className="invoice-form-input-field">
                        {suppliersData?.is_gst_certificate}
                        {suppliersData?.is_gst_certificate === null ? (
                          <div className="invoice-form-input-field-extra-holder">
                            <label className="required">GST Certificate</label>
                            <input
                              type="file"
                              {...register("isGSTCertificate")}
                              accept="application/pdf"
                            />
                            <div className="invoice-form-input-field-extra-holder">
                              {errors.isGSTCertificate &&
                                errors.isGSTCertificate.message}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="invoice-form-input-field">
                        <div className="invoice-form-input-field-extra-holder">
                          {showMSME ? (
                            <>
                              <label>Upload MSME Certificate</label>
                              <input
                                type="file"
                                {...register("msmeCertificate", {
                                  required: "*required",
                                })}
                                placeholder="MSME CERTIFICATE"
                                accept="application/pdf"
                              />
                            </>
                          ) : null}
                          {/* {errors.msmeCertificate && errors.msmeCertificate.message}
                {errors.partner_msme_status &&
                  errors.partner_msme_status.message} */}
                        </div>
                      </div>
                      <div className="invoice-form-input-field"></div>
                      <div className="invoice-form-input-field"></div>
                    </div>
                  </div>
                </div>
              </>
            ) : current === 2 ? (
              <>
                <div className="invoice-form-container">
                  <div className="invoice-form-container-details">
                    <div className="invoice-business-address">
                      <div className="invoice-billing-shipping">
                        <div className="invoice-billing">
                          <div className="invoice-billing-field">
                            <label>
                              <h4 className="required">BILLING ADDRESS:</h4>
                            </label>
                            <textarea
                              id="readonly-text-area"
                              type="text"
                              {...register("business_billing_address", {
                                required: "*required",
                              })}
                              defaultValue={getValues(
                                "business_billing_address",
                              )}
                              rows={5}
                              readOnly
                              disabled={true}
                            ></textarea>
                          </div>
                          <div className="invoice-billing-field">
                            <label className="required" htmlFor="">
                              Billing State Name:
                            </label>
                            <input
                              id="readonly-text-area"
                              type="text"
                              defaultValue={getValues("business_state_name")}
                              readOnly
                              disabled={true}
                            />
                          </div>
                          {/* <div className="invoice-billing-field">
                            <label>Billing State/UT Code</label>
                            <input type="text" />
                          </div> */}
                        </div>
                        <div className="invoice-shipping">
                          <div className="invoice-shipping-field">
                            <label>
                              <h4 className="required">SHIPPING ADDRESS:</h4>
                            </label>
                            {/* <textarea rows={5}></textarea> */}
                            <textarea
                              type="text"
                              {...register("business_shipping_address", {
                                required: "*required",
                              })}
                              defaultValue={getValues(
                                "business_billing_address",
                              )}
                              rows={5}
                            ></textarea>
                          </div>
                          <div className="invoice-shipping-field">
                            <label className="required">Shipping State:</label>
                            <input
                              type="text"
                              defaultValue={getValues("business_state_name")}
                            />
                          </div>
                          {/* <div className="invoice-shipping-field">
                            <label>Shipping State/UT Code:</label>
                            <input type="text" />
                          </div> */}
                        </div>
                      </div>
                      <div className="invoice-values">
                        <div className="invoice-values-field-rev">
                          <label className="required">
                            Whether GST payable under RCM{" "}
                          </label>
                          <div className="invoice-values-input-field-rev">
                            <select
                              {...register("gst_under_rcm", {
                                required: "*required",
                              })}
                              onChange={handleGSTRCM}
                            >
                              <option value="">Select GST RCM</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                            <div className="invoice-form-input-field-extra-holder">
                              {errors?.gst_under_rcm && (
                                <p className="errorMsg">
                                  {errors?.gst_under_rcm.message}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          className="invoice-values-field"
                          style={{ marginBottom: "0px" }}
                        >
                          <label className="required">
                            Basic invoice value (in ₹)
                          </label>
                          <div
                            className={
                              !isEinvoiceEnabled ||
                              getValues("is_einvoice")?.toUpperCase() === "YES"
                                ? "yes-selected"
                                : "invoice-values-input-field"
                            }
                          >
                            <input
                              className="invoice-input-amount"
                              type="text"
                              maxLength={13}
                              placeholder="Basic invoice value"
                              {...register("basic_invoice_value", {
                                required: "*required",
                                pattern: {
                                  value: /^[0-9]{1,10}((.)[0-9]{0,2}){0,1}$/,
                                  message: "can't exceed 100 Cr",
                                },
                              })}
                              disabled={
                                !isEinvoiceEnabled ||
                                getValues("is_einvoice")?.toUpperCase() ===
                                  "YES"
                                  ? true
                                  : false
                              }
                              onChange={(e) => handleInvoiceValues(e)}
                              // onChange={handleInvoiceValues}
                            />
                            <div className="invoice-form-input-field-extra-holder">
                              {errors?.basic_invoice_value &&
                                errors?.basic_invoice_value.type ===
                                  "pattern" && (
                                  <p className="errorMsg">
                                    {errors?.basic_invoice_value.message}
                                  </p>
                                )}
                              {errors?.basic_invoice_value &&
                                errors?.basic_invoice_value.type ===
                                  "required" && (
                                  <p className="errorMsg">
                                    {errors?.basic_invoice_value.message}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            !isEinvoiceEnabled ||
                            getValues("is_einvoice")?.toUpperCase() === "YES"
                              ? "yes-selected"
                              : "invoice-values-field"
                          }
                        >
                          <label>Discount if any</label>
                          <input
                            className="invoice-input-amount"
                            type="text"
                            maxLength={13}
                            placeholder="Discount"
                            {...register("discount")}
                            disabled={
                              !isEinvoiceEnabled ||
                              getValues("is_einvoice")?.toUpperCase() === "YES"
                                ? true
                                : false
                            }
                            onChange={(e) => handleInvoiceValues(e)}
                          />
                        </div>
                        <div className="invoice-values-field">
                          <label>
                            Transport Charge/Insurance Charge/Others
                          </label>
                          <input
                            className="invoice-input-amount"
                            type="text"
                            maxLength={13}
                            placeholder="TC/IC/Others"
                            {...register("commodity_charges")}
                            onChange={(e) => handleInvoiceValues(e)}
                          />
                        </div>
                        <div className="invoice-values-field">
                          <label> Assessable Value</label>
                          <input
                            className="invoice-input-amount"
                            id="readonly-text-area"
                            type="text"
                            placeholder="Assessable value"
                            {...register("assessable_value")}
                            disabled
                          />
                        </div>
                        <div
                          className={
                            !isEinvoiceEnabled ||
                            getValues("is_einvoice")?.toUpperCase() === "YES"
                              ? "yes-selected"
                              : "invoice-values-field"
                          }
                        >
                          <label>Customs Duty/CVD/SWC/Others</label>
                          <input
                            className="invoice-input-amount"
                            type="text"
                            maxLength={13}
                            placeholder="Customs duty"
                            {...register("customs_duty_others")}
                            onChange={(e) => handleInvoiceValues(e)}
                            disabled={
                              !isEinvoiceEnabled ||
                              getValues("is_einvoice")?.toUpperCase() === "YES"
                                ? true
                                : false
                            }
                          />
                        </div>
                        <div className="invoice-values-field">
                          <label>Taxable Value</label>
                          <input
                            className="invoice-input-amount"
                            id="readonly-text-area"
                            type="text"
                            placeholder="Taxable Value"
                            {...register("taxable_value_of_invoice")}
                            disabled
                          />
                        </div>
                        <div
                          /*className="invoice-values-field"*/ className={
                            isRCM == 1
                              ? "yes-selected"
                              : !isEinvoiceEnabled ||
                                  getValues("is_einvoice")?.toUpperCase() ===
                                    "YES"
                                ? "yes-selected"
                                : "no-selected"
                          }
                        >
                          <label>CGST Total</label>
                          <input
                            className="invoice-input-amount"
                            type="text"
                            maxLength={13}
                            placeholder="CGST Total"
                            {...register("cgst")}
                            disabled={
                              isRCM
                                ? true
                                : !isEinvoiceEnabled ||
                                    getValues("is_einvoice")?.toUpperCase() ===
                                      "YES"
                                  ? true
                                  : false
                            }
                            onChange={(e) => handleInvoiceValues(e)}
                          />
                        </div>
                        <div
                          /*className="invoice-values-field"*/ className={
                            isRCM == 1
                              ? "yes-selected"
                              : !isEinvoiceEnabled ||
                                  getValues("is_einvoice")?.toUpperCase() ===
                                    "YES"
                                ? "yes-selected"
                                : "no-selected"
                          }
                        >
                          <label>SGST Total</label>
                          <input
                            className="invoice-input-amount"
                            type="text"
                            maxLength={13}
                            placeholder="SGST Total"
                            {...register("sgst")}
                            disabled={
                              isRCM
                                ? true
                                : !isEinvoiceEnabled ||
                                    getValues("is_einvoice")?.toUpperCase() ===
                                      "YES"
                                  ? true
                                  : false
                            }
                            onChange={(e) => handleInvoiceValues(e)}
                          />
                        </div>
                        <div
                          /*className="invoice-values-field"*/ className={
                            isRCM == 1
                              ? "yes-selected"
                              : !isEinvoiceEnabled ||
                                  getValues("is_einvoice")?.toUpperCase() ===
                                    "YES"
                                ? "yes-selected"
                                : "no-selected"
                          }
                        >
                          <label>UTGST Total</label>
                          <input
                            className="invoice-input-amount"
                            type="text"
                            maxLength={13}
                            placeholder="UTGST Total"
                            {...register("utgst")}
                            disabled={
                              isRCM
                                ? true
                                : !isEinvoiceEnabled ||
                                    getValues("is_einvoice")?.toUpperCase() ===
                                      "YES"
                                  ? true
                                  : false
                            }
                            onChange={(e) => handleInvoiceValues(e)}
                          />
                        </div>
                        <div
                          /*className="invoice-values-field"*/ className={
                            isRCM == 1
                              ? "yes-selected"
                              : !isEinvoiceEnabled ||
                                  getValues("is_einvoice")?.toUpperCase() ===
                                    "YES"
                                ? "yes-selected"
                                : "no-selected"
                          }
                        >
                          <label>IGST Total</label>
                          <input
                            className="invoice-input-amount"
                            type="text"
                            maxLength={13}
                            placeholder="IGST Total"
                            {...register("igst")}
                            disabled={
                              isRCM
                                ? true
                                : !isEinvoiceEnabled ||
                                    getValues("is_einvoice")?.toUpperCase() ===
                                      "YES"
                                  ? true
                                  : false
                            }
                            onChange={(e) => handleInvoiceValues(e)}
                          />
                        </div>
                        <div
                          className={
                            !isEinvoiceEnabled ||
                            getValues("is_einvoice")?.toUpperCase() === "YES"
                              ? "yes-selected"
                              : "invoice-values-field"
                          }
                        >
                          <label>Cess</label>
                          <input
                            className="invoice-input-amount"
                            type="text"
                            maxLength={13}
                            placeholder="Cess"
                            {...register("cess")}
                            disabled={
                              !isEinvoiceEnabled ||
                              getValues("is_einvoice")?.toUpperCase() === "YES"
                                ? true
                                : false
                            }
                            onChange={(e) => handleInvoiceValues(e)}
                          />
                        </div>
                        <div
                          className={
                            !isEinvoiceEnabled ||
                            getValues("is_einvoice")?.toUpperCase() === "YES"
                              ? "yes-selected"
                              : "invoice-values-field"
                          }
                        >
                          <label>Round off value (+/-)</label>
                          <input
                            className="invoice-input-amount"
                            type="text"
                            maxLength={13}
                            placeholder="Round off value"
                            {...register("round_off_value")}
                            // onChange={(e) => handleInvoiceValues(e)}
                            onChange={(e) => {
                              isManualRoundOff.current = true;
                              handleInvoiceValues(e);
                            }}
                            disabled={
                              !isEinvoiceEnabled ||
                              getValues("is_einvoice")?.toUpperCase() === "YES"
                                ? true
                                : false
                            }
                          />
                        </div>
                        <div className="invoice-values-field">
                          <label>Total Invoice amount(in ₹)</label>
                          <input
                            className="invoice-input-amount"
                            id="readonly-text-area"
                            type="text"
                            // placeholder="Total Invoice amount"
                            // min="0"
                            {...register("total_invoice_amount", {
                              pattern: {
                                value: /^[0-9]{10}\.[0-9]{2}$/,
                                message: "invalid value",
                              },
                            })}
                            disabled
                          />
                          {/* {errors.total_invoice_amount && (
                              <p>{errors.total_invoice_amount.message}</p>
                            )} */}
                        </div>
                        <div className="invoice-values-field">
                          <label>Total Tax amount(in ₹)</label>
                          <input
                            className="invoice-input-amount"
                            id="readonly-text-area"
                            type="text"
                            placeholder="Total Tax amount"
                            {...register("total_tax_amount")}
                            disabled
                          />
                        </div>
                        <div className="invoice-values-field">
                          <label>Total Invoice amount In Words:</label>
                          <textarea
                            id="readonly-text-area"
                            type="text"
                            {...register("total_invoice_amount_in_words")}
                            cols={30}
                            rows={3}
                            readOnly
                            disabled
                            style={{ resize: "none" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="invoice-einvoice-invoice-values">
                      <div className="invoice-po-meta">
                        <div className="invoice-po-meta-field-rev">
                          <label className="required">Document Type:</label>
                          <div
                            className={
                              !isEinvoiceEnabled ||
                              getValues("is_einvoice")?.toUpperCase() === "YES"
                                ? "disable-test"
                                : "invoice-po-meta-input-field-rev"
                            }
                          >
                            <select
                              {...register("document_type", {
                                required: "*required",
                              })}
                              disabled={
                                !isEinvoiceEnabled ||
                                getValues("is_einvoice")?.toUpperCase() ===
                                  "YES"
                                  ? true
                                  : false
                              }
                            >
                              <option value="">Document Type</option>
                              <option value="INV">Invoice</option>
                              <option value="DBN">Debit note</option>
                              <option value="CRN">Credit note</option>
                            </select>
                            <div className="invoice-form-input-field-extra-holder">
                              {errors?.document_type && (
                                <p className="errorMsg">
                                  {errors?.document_type.message}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          className="invoice-po-meta-field"
                          id="invoice-po-meta-field-CRN-No"
                        >
                          <label className="required">INV/DBN/CRN No:</label>
                          <div
                            className={
                              !isEinvoiceEnabled ||
                              getValues("is_einvoice")?.toUpperCase() === "YES"
                                ? "disable-test"
                                : "invoice-po-meta-input-field"
                            }
                          >
                            <input
                              type="text"
                              placeholder="Enter Document No"
                              {...register("document_no", {
                                required: "*required",
                                pattern: {
                                  value: /^[a-zA-Z0-9\/-]*$/,
                                  message:
                                    "Only letters, numbers, '-' and '/' are allowed",
                                },
                              })}
                              disabled={
                                !isEinvoiceEnabled ||
                                getValues("is_einvoice")?.toUpperCase() ===
                                  "YES"
                                  ? true
                                  : false
                              }
                            />
                            <div className="invoice-form-input-field-extra-holder">
                              {errors?.document_no && (
                                <p className="errorMsg">
                                  {errors?.document_no.message}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          className="invoice-po-meta-field"
                          id="invoice-po-meta-field-CRNDate" /*style={{height:'5.4rem'}}*/
                        >
                          <label className="required">INV/DBN/CRN Date:</label>
                          <div
                            className={
                              !isEinvoiceEnabled ||
                              getValues("is_einvoice")?.toUpperCase() === "YES"
                                ? "disable-test"
                                : "invoice-po-meta-input-field"
                            }
                            id="invoice-po-meta-input-field-date"
                          >
                            <Controller
                              name="document_date"
                              control={control}
                              rules={{
                                required: "*required",
                                validate: (value) =>
                                  (value &&
                                    moment(
                                      value,
                                      "YYYY-MM-DD",
                                      true,
                                    ).isValid()) ||
                                  "Invalid date",
                              }}
                              render={({ field }) => (
                                <DatePicker
                                  selected={
                                    field.value ? new Date(field.value) : null
                                  }
                                  onChange={(date) =>
                                    field.onChange(
                                      date
                                        ? moment(date).format("YYYY-MM-DD")
                                        : null,
                                    )
                                  }
                                  placeholderText="Click to Select Date"
                                  minDate={mindate}
                                  maxDate={maxdate}
                                  dateFormat="dd-MM-yyyy"
                                  onKeyDown={(e) => {
                                    e.preventDefault();
                                  }}
                                  disabled={
                                    !isEinvoiceEnabled ||
                                    getValues("is_einvoice")?.toUpperCase() ===
                                      "YES"
                                      ? true
                                      : false
                                  }
                                />
                              )}
                            />
                            <div className="invoice-form-input-field-extra-holder">
                              {errors?.document_date && (
                                <p className="errorMsg">
                                  {errors?.document_date.message}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <br />
                        <div
                          className={
                            watch("document_type") === "CRN"
                              ? "crn-compact-ui"
                              : ""
                          }
                        >
                          {watch("document_type") === "CRN" &&
                            CRN_REFERENCE_LOBS.includes(
                              watch("business_code"),
                            ) && (
                              <>
                                <div className="invoice-po-meta-field">
                                  <label className="required">
                                    CRN Ref Invoice No :
                                  </label>
                                  {(watch("originalInvoices")?.filter(
                                    (item) =>
                                      item?.original_invoice_no &&
                                      item?.original_invoice_date,
                                  ).length || 0) === 0}

                                  <div className="invoice-po-meta-input-field crn-ref-wrapper">
                                    <button
                                      type="button"
                                      className={`crn-button1 ${
                                        (watch("originalInvoices")?.filter(
                                          (item) =>
                                            item?.original_invoice_no &&
                                            item?.original_invoice_date,
                                        ).length || 0) === 0
                                          ? "required-border"
                                          : ""
                                      }`}
                                      onClick={() => setShowCRNModal(true)}
                                    >
                                      {/* Add */}
                                      <>
                                        <EditNoteOutlinedIcon fontSize="large" />
                                      </>
                                    </button>

                                    <span className="crn-added-count">
                                      Added:{" "}
                                      {watch("originalInvoices")?.filter(
                                        (item) =>
                                          item?.original_invoice_no &&
                                          item?.original_invoice_date,
                                      ).length || 0}
                                    </span>
                                  </div>
                                </div>
                              </>
                            )}
                        </div>

                        <br />
                        <div className="invoice-po-meta-field">
                          <label>PO.No:</label>
                          <div
                            className="invoice-po-meta-input-field"
                            id="invoice-po-meta-input-field-el-date"
                          >
                            {getValues("po_type") !== "Non-PO" &&
                            getValues("po_type") !== "Engagement-Letter"
                              ? getValues("selected_purchase_order")
                              : "Not Applicable"}
                          </div>
                        </div>
                        <div className="invoice-po-meta-field">
                          <label>P.O./E.L DATE</label>
                          {/* <input
                              className="po-input"
                              type="text"
                              {...register("po_date")}
                              readOnly
                            /> */}
                          <div
                            className="invoice-po-meta-input-field"
                            id="invoice-po-meta-input-field-po-no" /*style={{marginTop:'10px'}}*/
                          >
                            {/* {getValues("po_type") !== "Non-PO" &&
                            getValues("po_type") !== "Engagement-Letter"
                              ? getValues("po_date")
                              : "Not Applicable"} */}
                            {getValues("po_type") === "Non-PO"
                              ? "Not Applicable"
                              : getValues("po_date") || "No Date Provided"}
                          </div>
                        </div>

                        <div
                          className="invoice-po-meta-field"
                          id="invoice-po-meta-field-Remain-PO" /*style={{marginTop:'23px'}}*/
                        >
                          <label>Remaining PO Amount(in ₹) </label>
                          {/* <input value="90000"></input> */}
                          {/* <input
                              className="invoice-details-table-remaining-amount po-input"
                              type="text"
                              {...register("remaining_amount")}
                              readOnly
                            /> */}
                          <div
                            className="invoice-po-meta-input-field"
                            id="invoice-po-meta-input-field-po-no"
                          >
                            {getValues("po_type") !== "Non-PO" &&
                            getValues("po_type") !== "Engagement-Letter"
                              ? getValues("remaining_amount")
                              : "Not Applicable"}
                          </div>
                        </div>
                        <div
                          className="invoice-po-meta-field"
                          id="invoice-po-meta-field-email" /*style={{marginTop:'20px',height:'54px'}}*/
                        >
                          <label className="required">
                            Email ID Of Person who has issued PO:
                          </label>
                          <div className="invoice-po-meta-input-field">
                            <input
                              type="email"
                              placeholder="Contact Person Email"
                              {...register("contact_person_email_id", {
                                required: "*required",
                                pattern: {
                                  value:
                                    /^[a-zA-Z0-9._-]{2,200}@adityabirlacapital\.com$/i,
                                  message:
                                    "Entered email must be @adityabirlacapital.com",
                                },
                              })}
                            ></input>
                            <div className="invoice-form-input-field-extra-holder">
                              {errors?.contact_person_email_id && (
                                <p className="errorMsg">
                                  {errors?.contact_person_email_id.message}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="einvoice-values">
                        <div className="einvoice-values-field">
                          <label className="required">
                            HSN Code [of main item]
                          </label>
                          <div
                            className={
                              !isEinvoiceEnabled ||
                              getValues("is_einvoice")?.toUpperCase() === "YES"
                                ? "disable-test"
                                : "einvoice-values-input-field"
                            }
                            style={{ marginBottom: "0px" }}
                          >
                            <input
                              type="text"
                              placeholder="HSN Code"
                              {...register("hsncode_main_item", {
                                required: "*required",
                              })}
                              disabled={
                                !isEinvoiceEnabled ||
                                getValues("is_einvoice")?.toUpperCase() ===
                                  "YES"
                                  ? true
                                  : false
                              }
                            />
                            <div className="invoice-form-input-field-extra-holder">
                              {errors?.hsncode_main_item && (
                                <p className="errorMsg">
                                  {errors?.hsncode_main_item.message}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          className="einvoice-values-field"
                          id="einvoice-values-field"
                        >
                          <label className="required">
                            Upload invoice copy
                          </label>
                          <div
                            className="file-upload"
                            style={{ marginTop: "4px" }}
                          >
                            <img src={uploadImg} alt="upload" class="img" />
                            <input
                              type="file"
                              accept="application/pdf"
                              name="invoiceFile"
                              {...register("invoiceFile", {
                                required:
                                  selectedInvoice?.invoice_copy == undefined &&
                                  "required",
                              })}
                              onChange={handleFileChange}
                            />
                            <h3 class="label">
                              {" "}
                              {getFileName(
                                selectedName ||
                                  ((selectedInvoice?.invoice_copy !=
                                    undefined ||
                                    selectedInvoice?.invoice_copy != null) &&
                                    selectedInvoice?.invoice_copy.substring(
                                      String(
                                        selectedInvoice?.invoice_copy,
                                      ).indexOf("~") + 1,
                                      selectedInvoice?.invoice_copy.length,
                                    )) ||
                                  "Choose File",
                              )}{" "}
                            </h3>
                            <div
                              className="invoice-form-input-field-extra-holder"
                              style={{
                                marginLeft: "41px",
                                marginTop: "-8px",
                              }}
                            >
                              {errors?.invoiceFile && (
                                <p className="errorMsg">
                                  {errors?.invoiceFile.message}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div
                          className="einvoice-values-field"
                          id="einvoice-values-field"
                        >
                          <label>Upload support documents</label>
                          <div
                            className="file-upload"
                            style={{ marginBottom: "4px" }}
                          >
                            <img src={uploadImg} alt="upload" class="img" />
                            <input
                              type="file"
                              //placeholder="Upload"
                              accept="application/pdf"
                              name="supportFile"
                              {...register("supportFile", {
                                // required: "*required",
                              })}
                              onChange={handleSupportFileChange}
                            />
                            <h3 class="label">
                              {" "}
                              {getFileName(
                                selectedSFName ||
                                  ((selectedInvoice?.supporting_documents !=
                                    undefined ||
                                    selectedInvoice?.supporting_documents !=
                                      null) &&
                                    selectedInvoice?.supporting_documents.substring(
                                      String(
                                        selectedInvoice?.supporting_documents,
                                      ).indexOf("~") + 1,
                                      selectedInvoice?.supporting_documents
                                        .length,
                                    )) ||
                                  "Choose File",
                              )}{" "}
                            </h3>

                            <div
                              className="invoice-form-input-field-extra-holder"
                              style={{
                                marginLeft: "51px",
                                marginTop: "-11px",
                              }}
                            >
                              {errors?.supportFile && (
                                <p className="errorMsg">
                                  {errors?.supportFile.message}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="einvoice-values-field">
                          <label> E-invoice Available</label>
                          <div className="einvoice-values-input-field">
                            <select {...register("eway_bill_available_or_not")}>
                              <option value="">Select</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                            {errors?.eway_bill_available_or_not && (
                              <p className="errorMsg">
                                {errors?.eway_bill_available_or_not.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="einvoice-values-field">
                          <label> E-way Bill no.(if applicable)</label>
                          <div className="einvoice-values-input-field">
                            <input type="text" placeholder="E-way Bill no." />
                          </div>
                        </div>
                        {/* <div className="einvoice-values-field">
                          <label>QR code with IRN no.</label>
                          <div className="einvoice-values-input-field">
                            <input
                              type="text"
                              placeholder="QR code with IRN No"
                              {...register("qr_code_with_irn_no")}
                            />
                          </div>
                        </div> */}
                        <div className="einvoice-values-field">
                          <label>Invoice status in GSTN portal</label>
                          <div className="einvoice-values-input-field">
                            <input
                              type="text"
                              placeholder="Invoice Upload Status in GSTN Portal"
                              {...register("irp_invoice_upload_status")}
                            />
                          </div>
                        </div>
                        <div className="einvoice-values-field">
                          <label> Whether Imports(yes/no)</label>
                          <div className="einvoice-values-input-field">
                            <select
                              {...register("whether_imports", {
                                // required: "*required",
                              })}
                              onChange={(e) => setIsImport(e.target.value)}
                            >
                              <option value="" selected>
                                Select
                              </option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                            {errors?.whether_imports && (
                              <p className="errorMsg">
                                {errors?.whether_imports.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="einvoice-values-field">
                          <label>Import Date</label>
                          <div
                            /*className="einvoice-values-input-field"*/ className={
                              isImport === "No"
                                ? "einvoice-values-input-field-no"
                                : "einvoice-values-input-field"
                            }
                          >
                            <input
                              type="date"
                              {...register("date_for_import_of_goods")}
                              disabled={isImport === "No" ? 1 : 0}
                            />
                          </div>
                        </div>
                        <div className="einvoice-values-field">
                          <label>Bill Of Entry No</label>
                          <div
                            /*className="einvoice-values-input-field"*/ className={
                              isImport === "No"
                                ? "einvoice-values-input-field-no"
                                : "einvoice-values-input-field"
                            }
                          >
                            <input
                              type="text"
                              placeholder="Bill Of Entry No"
                              {...register("bill_of_entryno")}
                              disabled={isImport === "No" ? 1 : 0}
                            />
                          </div>
                        </div>

                        <div className="einvoice-values-field"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            <div className="btn-box">
              <input
                className="button"
                disabled={current === 0}
                onClick={handleBack}
                value="Back"
                type="button"
              />

              <input
                className="button"
                disabled={current <= 1 || isValidDraftValue === 0}
                onClick={(e) => {
                  handleSubmit(handleDraft)(e);
                }}
                value="Draft"
                type="button"
              />
              {showDraftModal && (
                <div
                  className="modal-backdrop"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="draftTitle"
                  aria-describedby="draftDesc"
                >
                  <div className="modal-content" tabIndex={-1}>
                    <div className="modal-header">
                      {error ? (
                        <>
                          <h2>
                            <CancelOutlinedIcon fontSize="large" /> Draft
                            Invoice failed
                          </h2>
                          <p>{errorMessage}</p>
                        </>
                      ) : (
                        <>
                          <h2>
                            <CheckCircleOutlineOutlinedIcon
                              sx={{ fontSize: 35 }}
                            />{" "}
                            Invoice saved as Draft
                          </h2>
                          <p id="draftDesc">
                            You can come back later to complete and submit it.
                          </p>
                        </>
                      )}
                    </div>
                    <div className="modal-body">
                      <div className="modal-section">
                        {/* <p className="section-title">Next steps</p> */}
                        <button
                          className="btn-postinvoice btn-secondary"
                          onClick={() => {
                            setShowDraftModal(false);
                            setCurrentTab(0);
                            Invoices(userID, getValues("business_code"));
                          }}
                        >
                          Go to Dashboard
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <input
                className="button"
                value={current === steps.length - 1 ? "Submit" : "Next"}
                onClick={(e) => {
                  handleSubmit(handleNext)(e);
                }}
                disabled={!isValidInvoiceValue}
                type="button"
              />
            </div>
            {showTroubleModal && (
              <div
                className="modal-backdrop"
                role="dialog"
                aria-modal="true"
                aria-labelledby="postSubmitTitle"
                aria-describedby="postSubmitDesc"
              >
                <div className="modal-content" tabIndex={-1}>
                  <div className="modal-header">
                    {error ? (
                      <>
                        {/* <h2 className="text-red-600">❌ Invoice Submission Failed</h2> */}
                        <h2>
                          <CancelOutlinedIcon fontSize="large" /> Invoice
                          Submission Failed
                        </h2>
                        <p>{errorMessage}</p>
                        <div className="modal-footer">
                          <button
                            className="btn-postinvoice btn-primary"
                            onClick={() => {
                              setShowTroubleModal(false);
                              setCurrentTab(0);
                              Invoices(userID, getValues("business_code"));
                            }}
                          >
                            Go to Dashboard
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <h2>
                          <CheckCircleOutlineOutlinedIcon
                            sx={{ fontSize: 40 }}
                          />{" "}
                          Invoice Submitted Successfully
                        </h2>
                        <p>What would you like to do next?</p>
                      </>
                    )}
                  </div>

                  {!error && (
                    <div
                      className="modal-body"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "2rem",
                      }}
                    >
                      <div className="modal-section" style={{ flex: 1 }}>
                        <p className="section-title">Want to give feedback?</p>
                        <button
                          className="btn-postinvoice btn-primary"
                          onClick={() => {
                            setShowTroubleModal(false);
                            setCurrentTab(2);
                          }}
                        >
                          Submit Feedback
                        </button>
                      </div>

                      <div
                        className="modal-section"
                        style={{ flex: 1, textAlign: "center" }}
                      >
                        <p className="section-title">Having trouble?</p>
                        <button
                          className="btn-postinvoice btn-primary"
                          onClick={() => {
                            setShowTroubleModal(false);
                            setCurrentTab(3);
                          }}
                        >
                          Submit Ticket
                        </button>
                      </div>

                      <div
                        className="modal-section"
                        style={{ flex: 1, textAlign: "right" }}
                      >
                        <p className="section-title">&nbsp;</p>
                        <button
                          className="btn-postinvoice btn-primary"
                          onClick={() => {
                            setShowTroubleModal(false);
                            setCurrentTab(0);
                            Invoices(userID, getValues("business_code"));
                          }}
                        >
                          Go to Dashboard
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            <Modal open={showCRNModal}>
              <div className="crn-modal">
                <div className="crn-header">
                  <h3>Reference Invoice Details For Credit Note </h3>

                  <button
                    type="button"
                    className="crn-close-btn"
                    onClick={() => setShowCRNModal(false)}
                  >
                    ✕
                  </button>
                </div>

                <div className="crn-scroll">
                  {fields.map((item, index) => (
                    <div key={item.id} className="crn-row">
                      <div className="crn-field">
                        <label>Invoice Number</label>

                        <input
                          placeholder="Invoice No"
                          className="crn-input"
                          {...register(
                            `originalInvoices.${index}.original_invoice_no`,
                            {
                              required: "Invoice No is required",
                            },
                          )}
                        />

                        {errors?.originalInvoices?.[index]
                          ?.original_invoice_no && (
                          <p className="errorMsg">
                            {
                              errors.originalInvoices[index].original_invoice_no
                                .message
                            }
                          </p>
                        )}
                      </div>

                      <div className="crn-field">
                        <label>Invoice Date</label>

                        <input
                          type="date"
                          max={new Date().toISOString().split("T")[0]}
                          className="crn-input"
                          {...register(
                            `originalInvoices.${index}.original_invoice_date`,
                            {
                              required: "Date is required",
                            },
                          )}
                        />

                        {errors?.originalInvoices?.[index]
                          ?.original_invoice_date && (
                          <p className="errorMsg">
                            {
                              errors.originalInvoices[index]
                                .original_invoice_date.message
                            }
                          </p>
                        )}
                      </div>

                      <button
                        type="button"
                        className="remove-crn-btn"
                        onClick={() => remove(index)}
                      >
                        <DeleteIcon fontSize="medium" />
                      </button>
                    </div>
                  ))}
                </div>

                {fields.length >= 7 && (
                  <p className="errorMsg">Maximum 7 invoices allowed</p>
                )}

                <div className="crn-btns">
                  <button
                    type="button"
                    className="crn-button"
                    disabled={fields.length >= 7}
                    onClick={() => {
                      if (fields.length < 7) {
                        append({
                          original_invoice_no: "",
                          original_invoice_date: "",
                        });
                      }
                    }}
                  >
                    Add
                  </button>

                  <button
                    type="button"
                    className="crn-button"
                    onClick={async () => {
                      let hasError = false;

                      fields.forEach((item, index) => {
                        const invoiceNo = getValues(
                          `originalInvoices.${index}.original_invoice_no`,
                        );

                        const invoiceDate = getValues(
                          `originalInvoices.${index}.original_invoice_date`,
                        );

                        if (!invoiceNo) {
                          setFormError(
                            `originalInvoices.${index}.original_invoice_no`,
                            {
                              type: "manual",
                              message: "Invoice No is required",
                            },
                          );

                          hasError = true;
                        }

                        if (!invoiceDate) {
                          setFormError(
                            `originalInvoices.${index}.original_invoice_date`,
                            {
                              type: "manual",
                              message: "Date is required",
                            },
                          );

                          hasError = true;
                        }
                      });

                      if (!hasError) {
                        setShowCRNModal(false);
                      }
                    }}
                  >
                    Done
                  </button>
                </div>
              </div>
            </Modal>
          </form>
        </>
        {/* FORM END*/}
      </div>
    </>
  );
};
export default InvoiceForm;
